<template>
	<div class="container" v-if="isClueChecked && hasCustomerInfo">
		<!-- 客户基本信息卡片（认领状态 - 完整信息） -->
		<div class="customer-card claimed">
			<div class="card-header">
				<span class="card-title">学员基本信息</span>

				<!-- 刷新按钮 + 编辑按钮 → 并排 -->
				<div class="card-actions">
					<van-icon name="replay" color="#fff" size="18" @click="refreshEntirePage"
						style="margin-right:20px;" />
					<van-icon v-if="isSelf" name="edit" color="#fff" size="18" @click="showEditDialog = true" />
				</div>
			</div>
			<div class="info-list">
				<div class="info-row">
					<div class="info-item">
						<span class="label">姓 名：</span>
						<span class="value">{{ form.name }}</span>
					</div>
					<div class="info-item" v-if="form.type">
						<span class="label">学员类型：</span>
						<span class="value">{{ form.type }}</span>
					</div>
				</div>

				<div class="info-row">
					<div class="info-item full">
						<span class="label">电话手机：</span>
						<span class="value">{{ form.phone }}</span>
					</div>
				</div>

				<div class="info-row arrow-row" v-if="form.type && form.type == '企业'">
					<div class="info-item">
						<span class="label">单位名称：</span>
						<span class="value">{{ form.company }}</span>
					</div>
				</div>

				<div class="info-row arrow-row" v-if="form.type && form.type == '个人'">
					<div class="info-item">
						<span class="label">当前班级：</span>
						<span class="value">{{ form.classInfo }}</span>
					</div>
					<div v-if="isSelf" class="tag-btn" @click="handleUpdateClassOpen" style="cursor: pointer;">分班</div>
				</div>

				<div class="info-row arrow-row" v-if="form.status">
					<div class="info-item">
						<span class="label">资料状态：</span>
						<span class="value">{{ form.status }}</span>
					</div>
					<div class="tag-btn" style="cursor: pointer;" @click="getMaterialOrderList">收集</div>
				</div>

				<!-- 客户来源：换成铅笔图标 -->
				<div v-if="isSelf" class="info-row arrow-row">
					<div class="info-item">
						<span class="label">客户来源：</span>
						<span class="value" style="color:#fff;">{{ form.source || '请选择客户来源' }}</span>
					</div>
					<div class="tag-btn" @click="showSourceDialog = true" style="cursor: pointer;">编辑
					</div>
				</div>
				<div v-else class="info-row">
					<div class="info-item full">
						<span class="label">客户来源：</span>
						<span class="value" style="color:#fff;">{{ form.source || '未知的客户来源' }}</span>
					</div>
				</div>

				<div class="info-row tag-row arrow-row">
					<div class="info-item">
						<span class="label">客户标签：</span>
						<div class="tag-list">
							<van-tag v-for="tag in form.tags" :key="tag" type="primary" color="#fff"
								text-color="#1677ff" size="large" @close="removeTag(tag)" class="customer-tag">
								{{ tag }}
							</van-tag>
						</div>
					</div>
					<!-- 加号按钮放在标签列表外面，永远不被挤掉 -->
					<van-icon v-if="isSelf" name="plus" color="#fff" size="18" class="add-tag"
						@click="showTagDialog = true" />
				</div>

				<div class="info-row">
					<div class="info-item full">
						<span class="label">负责同事：</span>
						<span class="value">{{ form.owner }}</span>
					</div>
				</div>
				<div class="info-row" v-if="form.colleagues">
					<div class="info-item full">
						<span class="label">协作同事：</span>
						<span class="value">{{ form.colleagues }}</span>
					</div>
				</div>
			</div>
		</div>
		<!-- 标签页导航 -->
		<van-tabs class="tabs" v-model:active="activeTab">
			<van-tab title="跟进">
				<div class="record-container">
					<div class="record-header">
						<span class="record-title">跟进记录</span>
						<div class="add-btn" v-if="isSelf" @click="showAddRecordDialog = true">
							<van-icon name="plus" size="14" color="#1677ff" />
							<span>添加记录</span>
						</div>
					</div>

					<div class="timeline">
						<div class="timeline-item" v-for="(item, idx) in followRecords" :key="idx">
							<div class="timeline-dot success">
								<van-icon name="success" color="#fff" size="12" />
							</div>
							<div class="timeline-content">
								<div class="timeline-row">
									<span class="timeline-time">{{ item.follow_time }}</span>
								</div>
								<div class="timeline-bubble" v-if="item.content">"{{ item.content }}"</div>
								<div class="timeline-operator" v-if="item.executor">
									<span>操作人: {{item.executor.name}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</van-tab>

			<van-tab title="订单" dot>
				<div class="order-page-container">
					<div class="order-card" v-for="(item, index) in orderList" :key="index">
						<!-- 订单头部 -->
						<div class="order-card-header">
							<div class="order-left">
								<div class="order-no">订单号：{{ item.order_id }}</div>
								<div class="order-project">报名项目：{{ item.good_name }}</div>
							</div>
							<div class="order-status-badge" :class="item.success === 1 ? 'paid' : 'unpaid'">
								{{ item.success === 1 ? '已支付': '待支付'}}
							</div>
						</div>

						<!-- 订单详情 -->
						<div class="order-card-body">
							<div class="order-row">
								<span class="order-label">创建时间</span>
								<span class="order-value">{{ item.create_time }}</span>
							</div>
							<div class="order-row" v-if="item.pay_time">
								<span class="order-label">支付时间</span>
								<span class="order-value">{{ item.pay_time }}</span>
							</div>
							<div class="order-row">
								<span class="order-label">订单金额</span>
								<span class="order-value price">¥ {{ item.price }}</span>
							</div>
							<!-- 开票状态（仅支付完成订单显示） -->
							<div class="order-row" v-if="item.success === 1">
								<span class="order-label">开票状态</span>
								<div class="order-value">
									<span v-if="item.invoice_status === 1">已开票</span>
									<van-button v-else-if="isSelf" size="small" type="primary" plain
										:loading="invoicingOrderId === item.order_id"
										@click="handleInvoice(item)">开票</van-button>
									<span v-else-if="item.invoice_status !== 1">未开票</span>
								</div>
							</div>
						</div>
					</div>

					<!-- 空订单提示 -->
					<div class="order-empty" v-if="!orderList || orderList.length === 0">
						<span>暂无订单信息</span>
					</div>
				</div>

				<!-- 悬浮添加按钮不动 -->
				<div class="float-add-btn" v-if="isSelf" @click="handleAddOrderOpen">
					<van-icon name="plus" size="24" color="#fff" />
				</div>
			</van-tab>

			<van-tab title="学情" v-if="form.type && form.type == '个人'">
				<div class="study-container">
					<div class="course-selector">
						<span class="course-label">当前课程：</span>
						<span class="course-name">低压电工</span>
						<van-icon name="arrow-down" size="14" color="#f5a623" />
					</div>

					<div class="progress-grid">
						<div class="progress-item">
							<div class="circle-progress">
								<div class="circle-inner"
									style="background: conic-gradient(#1677ff 0% 65%, #f2f3f5 65% 100%);">
									<span class="progress-text">65%</span>
								</div>
							</div>
							<div class="progress-label">题库练习进度</div>
						</div>
						<div class="progress-item">
							<div class="circle-progress">
								<div class="circle-inner"
									style="background: conic-gradient(#73d13d 0% 30%, #f2f3f5 30% 100%);">
									<span class="progress-text">30%</span>
								</div>
							</div>
							<div class="progress-label">线上学习进度</div>
						</div>
						<div class="progress-item">
							<div class="circle-progress">
								<div class="circle-inner"
									style="background: conic-gradient(#ff9a2e 0% 30%, #f2f3f5 30% 100%);">
									<span class="progress-text">30%</span>
								</div>
							</div>
							<div class="progress-label">线下学习进度</div>
						</div>
					</div>

					<div class="divider"></div>

					<div class="exam-section">
						<div class="exam-header">
							<span class="exam-title">最近5次模拟测试</span>
							<span class="exam-avg">平均正确率70%</span>
						</div>
						<div class="exam-list">
							<div class="exam-item" v-for="(item, index) in mockExams" :key="index">
								<span class="exam-num">第{{ index + 1 }}次</span>
								<span class="exam-date">{{ item.date }}</span>
								<span class="exam-time">{{ item.time }}</span>
								<span class="exam-rate">{{ item.rate }}%</span>
							</div>
						</div>
					</div>
				</div>
			</van-tab>

			<van-tab title="学员" v-else>
				<!-- 🔥 学员状态 TAB 切换 -->
				<van-tabs v-model:active="studentActiveTab" background="#f7f8fa" style="margin:10px 0;">
					<van-tab title="待报名"></van-tab>
					<van-tab title="待分班"></van-tab>
					<van-tab title="已在班"></van-tab>
				</van-tabs>

				<div class="class-enterprise-container">
					<div class="class-card" v-for="(item, index) in filteredStudentList" :key="index">
						<!-- 学员头部信息 -->
						<div class="class-card-header">
							<div class="class-student-base">
								<div class="class-student-name">{{ item.name }}</div>
								<div class="class-student-phone">{{ item.phone }}</div>
							</div>
							<div class="class-student-tags">
								<span class="tag-status fb">{{ item.fb_desc }}</span>
								<span class="tag-status zl">{{ item.zl_desc }}</span>
							</div>
						</div>

						<!-- 班级信息列表 -->
						<div class="class-card-body" v-for="(item2, index2) in item.classInfo" :key="index2">
							<div class="class-row">
								<span class="class-label">培训项目</span>
								<span class="class-value">{{ item2.business_type }} {{ item2.profession }}</span>
							</div>
							<div class="class-row">
								<span class="class-label">班级名称</span>
								<span class="class-value">{{ item2.class_name }}</span>
							</div>
							<div class="class-row">
								<span class="class-label">订单编号</span>
								<span class="class-value order-no">{{ item2.order_no }}</span>
							</div>
						</div>
					</div>
				</div>
			</van-tab>

			<van-tab title="开班">
				<div class="class-container">
					<div class="class-header">
						<div class="header-left">
							<span class="class-title">近期开班计划</span>
							<span class="class-update">更新于 {{nowTime}}</span>
						</div>
						<div class="header-right">
							<!-- 搜索输入框 -->
							<van-search v-model="searchKeyword" placeholder="搜索班级名称" shape="round"
								background="transparent"
								style="--van-search-background: transparent; --van-search-padding: 0; flex: 1;" />
							<!-- 刷新按钮 -->
							<van-button type="primary" size="small" icon="refresh" @click="refreshClassList"
								style="--van-button-font-size:12px; --van-button-padding: 4px 10px; margin-left: 8px;">
								刷新
							</van-button>
						</div>
					</div>

					<div class="class-list">
						<div class="class-item" v-for="(item, index) in filteredClassList" :key="index">
							<div class="class-item-title">
								<div class="class-tag"></div>
								<span class="class-name">{{ item.class_name }}</span>
							</div>
							<div class="class-info-row">
								<div class="class-info">
									<van-icon name="calendar-o" size="16" color="#999" />
									<span class="info-text">正式开班时间：{{ item.start_time }}</span>
								</div>
								<div class="class-info">
									<van-icon name="user-o" size="16" color="#999" />
									<span class="info-text">剩余名额：{{ item.remaining_seats }}人</span>
								</div>
							</div>
							<div class="class-info-row">
								<div class="class-info deadline">
									<van-icon name="clock-o" size="16" color="#f53f3f" />
									<span class="info-text">报名截止时间：{{ item.end_time }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</van-tab>

			<van-tab title="雷达">
				<div class="radar-container">
					<div class="radar-header">
						<span class="radar-title">营销页面访问排行</span>
						<span class="radar-date">截止至 2026-01-21</span>
					</div>

					<div class="radar-table">
						<div class="table-header">
							<span class="table-th">页面名称</span>
							<span class="table-th">访问时长</span>
						</div>
						<div class="table-body">
							<div class="table-row" v-for="(item, index) in radarList" :key="index">
								<span class="table-td page-name">{{ item.name }}</span>
								<span class="table-td duration">{{ item.duration }}</span>
							</div>
						</div>
					</div>
				</div>
			</van-tab>

			<van-tab title="工具">
				<div class="tool-container">
					<van-tabs v-model:active="toolTabActive" class="tool-sub-tabs">
						<van-tab title="常用" />
						<van-tab title="项目介绍" />
						<van-tab title="报名须知" />
						<van-tab title="政策文件" />
					</van-tabs>

					<div class="tool-list">
						<div class="tool-group" v-for="(group, index) in toolGroups" :key="index">
							<div class="tool-item" v-for="(item, idx) in group.items" :key="idx"
								@click="handleToolClick(item)">
								<div class="tool-left">
									<van-icon v-if="item.icon" :name="item.icon" :color="item.color" size="20"
										class="tool-icon" />
									<div class="tool-info">
										<div class="tool-name">{{ item.name }}</div>
										<div class="tool-desc">{{ item.desc }}</div>
									</div>
								</div>
								<van-icon name="arrow" size="16" color="#999" />
							</div>
						</div>
					</div>
				</div>
			</van-tab>
		</van-tabs>

	</div>

	<!-- 未认领 → 只显示“跟进”页面 -->
	<div class="only-follow" v-else>

		<!-- 客户基本信息卡片（未认领状态 - 简化信息） -->
		<div class="customer-card unclaimed">
			<div class="card-header">
				<span class="card-title">客户基本信息</span>

				<!-- 刷新按钮 + 编辑按钮 → 并排 -->
				<div class="card-actions">
					<van-icon name="replay" color="#fff" size="18" @click="refreshEntirePage"
						style="margin-right:20px;" />
					<van-icon v-if="isSelf" name="edit" color="#fff" size="18" @click="showEditDialog = true" />
				</div>
			</div>
			<div class="info-list">
				<div class="info-row">
					<div class="info-item">
						<span class="label">姓 名：</span>
						<span class="value">{{ form.name }}</span>
					</div>
					<div class="info-item" v-if="form.type">
						<span class="label">客户类型：</span>
						<span class="value">{{ form.type }}</span>
					</div>
				</div>

				<div class="info-row">
					<div class="info-item full">
						<span class="label">电话手机：</span>
						<span class="value">{{ form.phone }}</span>
					</div>
				</div>

				<!-- 客户来源：换成铅笔图标 -->
				<div v-if="isSelf" class="info-row arrow-row">
					<div class="info-item">
						<span class="label">客户来源：</span>
						<span class="value" style="color:#1e293b;">{{ form.source || '请选择客户来源' }}</span>
					</div>
					<div class="tag-btn" @click="showSourceDialog = true" style="cursor: pointer;margin-left: 6px;">编辑
					</div>
				</div>
				<div v-else class="info-row">
					<div class="info-item full">
						<span class="label">客户来源：</span>
						<span class="value" style="color:#1e293b;">{{ form.source || '未知的客户来源' }}</span>
					</div>
				</div>

				<div class="info-row tag-row arrow-row">
					<div class="info-item">
						<span class="label">客户标签：</span>
						<div class="tag-list">
							<van-tag v-for="tag in form.tags" :key="tag" type="primary" color="#fff"
								text-color="#1677ff" size="large" @close="removeTag(tag)" class="customer-tag">
								{{ tag }}
							</van-tag>
						</div>
					</div>
					<!-- 加号按钮放在标签列表外面，永远不被挤掉 -->
					<van-icon v-if="isSelf" name="plus" color="#fff" size="18" class="add-tag"
						@click="showTagDialog = true" />
				</div>

				<div class="info-row">
					<div class="info-item full">
						<span class="label">负责同事：</span>
						<span class="value">{{ form.owner }}</span>
					</div>
				</div>

				<div class="info-row" v-if="form.colleagues">
					<div class="info-item full">
						<span class="label">协作同事：</span>
						<span class="value">{{ form.colleagues }}</span>
					</div>
				</div>
			</div>
		</div>
		<van-tabs class="tabs" v-model:active="activeTab">
			<van-tab title="跟进">
				<div class="record-container">
					<div class="record-header">
						<span class="record-title">跟进记录</span>
						<div v-if="isSelf" class="add-btn" @click="showAddRecordDialog = true">
							<van-icon name="plus" size="14" color="#1677ff" />
							<span>添加记录</span>
						</div>
					</div>

					<div class="timeline">
						<div class="timeline-item" v-for="(item, idx) in followRecords" :key="idx">
							<div class="timeline-dot success">
								<van-icon name="success" color="#fff" size="12" />
							</div>
							<div class="timeline-content">
								<div class="timeline-row">
									<span class="timeline-time">{{ item.follow_time }}</span>
								</div>
								<div class="timeline-bubble" v-if="item.content">"{{ item.content }}"</div>
								<div class="timeline-operator" v-if="item.executor">
									<span>操作人: {{item.executor.name}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</van-tab>

			<van-tab title="订单" dot>
				<div class="order-page-container">
					<div class="order-card" v-for="(item, index) in orderList" :key="index">
						<!-- 订单头部 -->
						<div class="order-card-header">
							<div class="order-left">
								<div class="order-no">订单号：{{ item.order_id }}</div>
								<div class="order-project">报名项目：{{ item.good_name }}</div>
							</div>
							<div class="order-status-badge" :class="item.success === 1 ? 'paid' : 'unpaid'">
								{{ item.success === 1 ? '已支付': '待支付'}}
							</div>
						</div>

						<!-- 订单详情 -->
						<div class="order-card-body">
							<div class="order-row">
								<span class="order-label">创建时间</span>
								<span class="order-value">{{ item.create_time }}</span>
							</div>
							<div class="order-row" v-if="item.pay_time">
								<span class="order-label">支付时间</span>
								<span class="order-value">{{ item.pay_time }}</span>
							</div>
							<div class="order-row">
								<span class="order-label">订单金额</span>
								<span class="order-value price">¥ {{ item.price }}</span>
							</div>
							<!-- 开票状态（仅支付完成订单显示） -->
							<div class="order-row" v-if="item.success === 1">
								<span class="order-label">开票状态</span>
								<div class="order-value">
									<span v-if="item.invoice_status === 1">已开票</span>
									<van-button v-else-if="isSelf" size="small" type="primary" plain
										:loading="invoicingOrderId === item.order_id"
										@click="handleInvoice(item)">开票</van-button>
									<span v-else-if="item.invoice_status !== 1">未开票</span>
								</div>
							</div>
						</div>
					</div>

					<!-- 空订单提示 -->
					<div class="order-empty" v-if="!orderList || orderList.length === 0">
						<span>暂无订单信息</span>
					</div>
				</div>

				<!-- 悬浮添加按钮不动 -->
				<div class="float-add-btn" v-if="isSelf" @click="handleAddOrderOpen">
					<van-icon name="plus" size="24" color="#fff" />
				</div>
			</van-tab>

			<van-tab title="开班">
				<div class="class-container">
					<div class="class-header">
						<div class="header-left">
							<span class="class-title">近期开班计划</span>
							<span class="class-update">更新于 {{nowTime}}</span>
						</div>
						<div class="header-right">
							<!-- 搜索输入框 -->
							<van-search v-model="searchKeyword" placeholder="搜索班级名称" shape="round"
								background="transparent"
								style="--van-search-background: transparent; --van-search-padding: 0; flex: 1;" />
							<!-- 刷新按钮 -->
							<van-button type="primary" size="small" icon="refresh" @click="refreshClassList"
								style="--van-button-font-size:12px; --van-button-padding: 4px 10px; margin-left: 8px;">
								刷新
							</van-button>
						</div>
					</div>

					<div class="class-list">
						<div class="class-item" v-for="(item, index) in filteredClassList" :key="index">
							<div class="class-item-title">
								<div class="class-tag"></div>
								<span class="class-name">{{ item.class_name }}</span>
							</div>
							<div class="class-info-row">
								<div class="class-info">
									<van-icon name="calendar-o" size="16" color="#999" />
									<span class="info-text">正式开班时间：{{ item.start_time }}</span>
								</div>
								<div class="class-info">
									<van-icon name="user-o" size="16" color="#999" />
									<span class="info-text">剩余名额：{{ item.remaining_seats }}人</span>
								</div>
							</div>
							<div class="class-info-row">
								<div class="class-info deadline">
									<van-icon name="clock-o" size="16" color="#f53f3f" />
									<span class="info-text">报名截止时间：{{ item.end_time }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</van-tab>
		</van-tabs>
	</div>

	<!-- 编辑弹窗 -->
	<van-dialog v-model:show="showEditDialog" title="编辑客户信息" show-confirm-button show-cancel-button
		@confirm="handleEditConfirm">
		<van-form>
			<van-field v-model="editForm.name" label="姓名" placeholder="请输入姓名" />
			<van-field v-model="editForm.phone" label="电话" placeholder="请输入手机号" />
		</van-form>
	</van-dialog>

	<!-- 分班 单独弹窗 -->
	<van-dialog v-model:show="showClassDialog" title="选择分班信息" width="90%" show-confirm-button show-cancel-button>
		<van-form>
			<van-cell-group inset style="margin-top:5px; border-radius:12px;">
				<!-- 业务类型 -->
				<van-field label="业务类型" style="--van-field-label-width:80px;">
					<template #input>
						<select v-model="order_bussines1" class="pc-select no-arrow" @change="order_onBusinessChange">
							<option value="">请选择业务类型</option>
							<option v-for="item in order_columns_data1" :key="item.value" :value="item.text">
								{{ item.text }}
							</option>
						</select>
					</template>
				</van-field>

				<!-- 专业/工种 -->
				<van-field label="专业/工种" style="--van-field-label-width:80px;">
					<template #input>
						<select v-model="order_bussines2" class="pc-select no-arrow" @change="order_onGongChange">
							<option value="">请选择专业/工种</option>
							<option v-for="item in order_columns_data8" :key="item.value" :value="item.text">
								{{ item.text }}
							</option>
						</select>
					</template>
				</van-field>

				<van-field label="选择分班" style="--van-field-label-width:80px;">
					<template #input>
						<select v-model="order_class_selected" class="pc-select no-arrow">
							<option value="">暂不分班</option>
							<option v-for="cls in order_class_options" :key="cls.id" :value="cls.id">
								{{ cls.name }}
							</option>
						</select>
					</template>
				</van-field>
			</van-cell-group>

			<div style="margin:16px;">
				<van-button round block type="primary" @click="handleClassConfirm()">
					确认分班
				</van-button>
			</div>
		</van-form>
	</van-dialog>

	<!-- 客户来源 单独弹窗 -->
	<van-dialog v-model:show="showSourceDialog" title="选择客户来源" width="70%" show-confirm-button show-cancel-button
		@confirm="handleSourceConfirm">
		<div style="padding: 10px 0;">
			<select v-model="selectedSource"
				style="width:80%; margin-left: 10%; padding:10px; font-size:15px; border-radius:6px; border:1px solid #ddd;">
				<option value="">请选择客户来源</option>
				<option v-for="item in sourceList" :key="item" :value="item">
					{{ item }}
				</option>
			</select>
		</div>
	</van-dialog>

	<!-- 选择标签弹窗 -->
	<van-dialog v-model:show="showTagDialog" title="客户标签设置" width="90%" show-confirm-button show-cancel-button
		@confirm="handleTagConfirm">
		<div style="display: flex; height: 60vh; overflow: hidden;">

			<!-- 左侧竖排TAB -->
			<div class="left-tab-bar">
				<div v-for="(item, index) in tabList" :key="index" class="tab-item"
					:class="activeTabName === index ? 'active' : ''" @click="activeTabName = index">
					{{ item }}
				</div>
			</div>

			<!-- 右侧内容（已全部改为原生 radio） -->
			<div class="right-content">

				<!-- 1 咨询项目 -->
				<div v-if="activeTabName === 0">
					<div
						style="padding:10px; background:#f9fafb; border-radius:8px; display:flex;flex-wrap:wrap;gap:10px;">
						<label v-for="item in projectList" :key="item" style="display:flex;align-items:center;gap:4px;">
							<input type="checkbox" v-model="selectedProjects" :value="item" />
							<span>{{ item }}</span>
						</label>
					</div>
				</div>

				<!-- 2 咨询工种 -->
				<div v-if="activeTabName === 1">
					<div
						style="padding:10px; background:#f9fafb; border-radius:8px; display:flex;flex-wrap:wrap;gap:10px;">
						<label v-for="item in jobList" :key="item" style="display:flex;align-items:center;gap:4px;">
							<input type="checkbox" v-model="selectedJobs" :value="item" />
							<span>{{ item }}</span>
						</label>
					</div>
				</div>

				<!-- 3 新训复审查证 -->
				<div v-if="activeTabName === 2">
					<div
						style="padding:10px; background:#f9fafb; border-radius:8px; display:flex;flex-wrap:wrap;gap:12px;">
						<label v-for="item in trainList" :key="item" style="display:flex;align-items:center;gap:4px;">
							<input type="checkbox" v-model="selectedTrains" :value="item" />
							<span>{{ item }}</span>
						</label>
					</div>
				</div>

				<!-- 4 客户性质 → 改用 checkbox 实现可取消单选 -->
				<div v-if="activeTabName === 3" style="padding:15px;">
					<label v-for="item in natureList" :key="item"
						style="display:flex;align-items:center;gap:8px; margin-bottom:10px;">
						<input type="checkbox" :value="item" :checked="selectedNature === item"
							@click="handleSingleCheck('nature', item, $event)" />
						<span>{{ item }}</span>
					</label>
				</div>

				<!-- 5 报价情况 → 原生 radio -->
				<div v-if="activeTabName === 4" style="padding:15px;">
					<label v-for="item in priceList" :key="item"
						style="display:flex;align-items:center;gap:8px; margin-bottom:10px;">
						<input type="checkbox" :value="item" :checked="selectedPrice === item"
							@click="handleSingleCheck('price', item, $event)" />
						<span>{{ item }}</span>
					</label>
				</div>

				<!-- 6 客资质量 → 原生 radio -->
				<div v-if="activeTabName === 5" style="padding:15px;">
					<label v-for="item in qualityList" :key="item"
						style="display:flex;align-items:center;gap:8px; margin-bottom:10px;">
						<input type="checkbox" :value="item" :checked="selectedQuality === item"
							@click="handleSingleCheck('quality', item, $event)" />
						<span>{{ item }}</span>
					</label>
				</div>

				<!-- 7 是否返点 → 原生 radio -->
				<div v-if="activeTabName === 6" style="padding:15px;">
					<label v-for="item in rebateList" :key="item"
						style="display:flex;align-items:center;gap:8px; margin-bottom:10px;">
						<input type="checkbox" :value="item" :checked="selectedRebate === item"
							@click="handleSingleCheck('rebate', item, $event)" />
						<span>{{ item }}</span>
					</label>
				</div>

				<!-- 8 地域信息 → 原生 radio -->
				<div v-if="activeTabName === 7" style="padding:15px;">
					<label v-for="item in areaList" :key="item"
						style="display:flex;align-items:center;gap:8px; margin-bottom:10px;">
						<input type="checkbox" :value="item" :checked="selectedArea === item"
							@click="handleSingleCheck('area', item, $event)" />
						<span>{{ item }}</span>
					</label>
				</div>

			</div>
		</div>
	</van-dialog>

	<!-- 添加跟进记录弹窗 -->
	<van-dialog v-model:show="showAddRecordDialog" title="添加跟进记录" show-confirm-button show-cancel-button
		cancel-text="取消" confirm-text="提交" :confirm-button-disabled="submitting"
		:confirm-button-text="submitting ? '提交中...' : '提交'" @confirm="handleAddRecord">
		<van-field v-model="addForm.content" label="跟进内容" type="textarea" rows="3" placeholder="请输入跟进内容"
			class="claim-code" />
	</van-dialog>

	<!-- 线索认领/新增客户 弹窗 -->
	<van-dialog v-model:show="showClaimDialog" title="客户线索" show-confirm-button :show-cancel-button="false"
		close-on-click-overlay="false" close-on-popstate="false" :before-close="() => false" @confirm="handleSubmit">
		<!-- 切换：绑定线索 / 新增客户 -->
		<van-tabs v-model:active="claimTab" background="#fff">
			<van-tab title="认领老线索"></van-tab>
			<van-tab title="添加新线索"></van-tab>
		</van-tabs>

		<!-- 1. 绑定老线索 -->
		<div v-if="claimTab === 0" style="margin-top:12px">
			<van-field v-model="claimCode" placeholder="请输入线索编码" clearable maxlength="32" class="claim-code" />
		</div>

		<!-- 2. 添加新客户 -->
		<div v-else style="margin-top:12px; display:flex; flex-direction:column; gap:10px">
			<van-field v-model="newCustomer.name" placeholder="请输入客户名称" label="姓名" class="claim-code" />
			<van-field v-model="newCustomer.phone" placeholder="请输入手机号" label="手机" type="tel" class="claim-code" />
			<van-field v-model="newCustomer.wechat" placeholder="请输入微信号" label="微信" class="claim-code" />

			<div class="claim-code" style="padding:0; overflow:hidden;">
				<select v-model="newCustomer.source"
					style="width:100%; height:44px; padding:0 14px; font-size:15px; border:none; outline:none; background:#f9fafb; border-radius:12px;">
					<option value="">请选择客户来源</option>
					<option v-for="item in sourceList" :key="item" :value="item" :selected="item === '企业微信'">
						{{ item }}
					</option>
				</select>
			</div>
		</div>
	</van-dialog>

	<!-- 报名助手弹窗 -->
	<van-dialog v-model:show="showOrderFormDialog" title="报名助手" width="90%" show-cancel-button cancel-text="关闭"
		:show-confirm-button="false">
		<van-form>
			<van-cell-group inset style="margin-top:5px; border-radius:12px;">

				<!-- 客户姓名 -->
				<van-field label="客户姓名" placeholder="请输入客户姓名" v-model="order_user_name"
					style="--van-field-label-width:80px;" class="order-price-input" />

				<!-- 业务类型 -->
				<van-field label="业务类型" style="--van-field-label-width:80px;">
					<template #input>
						<select v-model="order_bussines1" class="pc-select no-arrow" @change="order_onBusinessChange">
							<option value="">请选择业务类型</option>
							<option v-for="item in order_columns_data1" :key="item.value" :value="item.text">
								{{ item.text }}
							</option>
						</select>
					</template>
				</van-field>

				<!-- 专业/工种 -->
				<van-field label="专业/工种" style="--van-field-label-width:80px;">
					<template #input>
						<select v-model="order_bussines2" class="pc-select no-arrow" @change="order_onGongChange">
							<option value="">请选择专业/工种</option>
							<option v-for="item in order_columns_data8" :key="item.value" :value="item.text">
								{{ item.text }}
							</option>
						</select>
					</template>
				</van-field>

				<!-- 培训类型 → 下拉框 -->
				<van-field v-show="order_show_it3" label="培训类型" style="--van-field-label-width:80px;">
					<template #input>
						<select v-model="order_bussines3_id" @change="order_chossed_value" class="pc-select no-arrow">
							<option value="">请选择培训类型</option>
							<option v-for="option in order_radioOptions" :key="option.id" :value="option.id">
								{{ option.label }}
							</option>
						</select>
					</template>
				</van-field>

				<van-field label="选择分班" style="--van-field-label-width:80px;">
					<template #input>
						<select v-model="order_class_selected" class="pc-select no-arrow">
							<option value="">暂不分班</option>
							<option v-for="cls in order_class_options" :key="cls.id" :value="cls.id">
								{{ cls.name }}
							</option>
						</select>
					</template>
				</van-field>

				<!-- 订单金额 -->
				<van-field label="订单金额" placeholder="请输入订单金额" v-model="order_price"
					style="--van-field-label-width:80px;" class="order-price-input" />

				<!-- 收款单位 -->
				<van-field label="收款单位" style="--van-field-label-width:80px;">
					<template #input>
						<div style="display: flex; flex-wrap: wrap; gap: 12px; align-items: center;">
							<van-checkbox :checked="order_componey === '筑信学校'" @click="setPayeeStatus('筑信学校')"
								shape="circle" class="circle-checkbox">
								<span style="white-space: nowrap;">筑信学校</span>
							</van-checkbox>
							<van-checkbox :checked="order_componey === '筑信企业'" @click="setPayeeStatus('筑信企业')"
								shape="circle" class="circle-checkbox">
								<span style="white-space: nowrap;">筑信企业</span>
							</van-checkbox>
						</div>
					</template>
				</van-field>

				<!-- 学员告知书：改用 van-switch -->
				<van-field label="学员签约" style="--van-field-label-width:80px;">
					<template #input>
						<van-switch v-model="order_is_sign" :active-value="'1'" :inactive-value="'0'" size="18px"
							style="position: fixed;right: 30px;" />
					</template>
				</van-field>
			</van-cell-group>

			<div style="margin:16px;">
				<van-button round block type="primary" @click="order_SentMessage()" class="submit-order-btn">
					发送给客户
				</van-button>
			</div>
		</van-form>
	</van-dialog>

	<!-- 资料收集弹窗 - 订单列表 -->
	<van-dialog v-model:show="showMaterialDialog" title="报名资料收集" width="90%" :show-confirm-button="false"
		close-on-click-overlay>
		<div style="max-height: 70vh; overflow-y: auto; padding: 12px;">
			<div v-if="materialOrderList.length === 0" style="text-align: center; padding: 40px 0; color: #999;">
				暂无报名订单
			</div>
			<div v-for="order in materialOrderList" :key="order.out_trade_no" class="material-order-card">
				<div class="material-order-header">
					<span class="order-project">{{ order.good_name }}</span>
					<span class="order-status" :class="getMaterialStatusClass(order.material_status)">
						{{ getMaterialStatusText(order.material_status) }}
					</span>
				</div>
				<div class="material-order-body">
					<span class="order-project">{{ order.out_trade_no }}</span>
					<div class="required-fields-list">
						<div v-for="field in order.requiredFields" :key="field.field_name" class="required-field-item">
							<span class="field-label">{{ field.field_label }}</span>
							<van-icon :name="field.is_uploaded ? 'success' : 'close'"
								:color="field.is_uploaded ? '#10b981' : '#ef4444'" size="16" />
						</div>
					</div>
				</div>
				<div class="material-order-footer">
					<van-button size="small" type="primary" plain @click="openMaterialForm(order)">补充资料</van-button>
				</div>
			</div>
		</div>
	</van-dialog>

	<!-- 资料表单弹窗 -->
	<van-dialog v-model:show="showMaterialFormDialog" :title="`补充资料 - ${currentMaterialOrder?.course_cate || ''}`"
		width="95%" :show-confirm-button="false" close-on-click-overlay>
		<div style="max-height: 70vh; overflow-y: auto; padding: 16px;">
			<!-- 身份证上传（如果需要） -->
			<div v-if="requiredFields.some(f => f.field_name === 'id_card_front' || f.field_name === 'id_card_back')"
				class="material-form-section">
				<div class="section-title">身份认证</div>
				<div class="upload-row">
					<div class="upload-item">
						<div class="upload-label">身份证正面</div>
						<van-uploader :after-read="(file) => uploadMaterialImage(file, 'id_front')" max-count="1">
							<div class="upload-box">
								<img v-if="materialFormData.id_front" :src="materialFormData.id_front"
									class="upload-preview" />
								<van-icon v-else name="photograph" size="32" color="#999" />
							</div>
						</van-uploader>
					</div>
					<div class="upload-item">
						<div class="upload-label">身份证反面</div>
						<van-uploader :after-read="(file) => uploadMaterialImage(file, 'id_back')" max-count="1">
							<div class="upload-box">
								<img v-if="materialFormData.id_back" :src="materialFormData.id_back"
									class="upload-preview" />
								<van-icon v-else name="photograph" size="32" color="#999" />
							</div>
						</van-uploader>
					</div>
				</div>
			</div>

			<!-- 证件照 -->
			<div v-if="requiredFields.some(f => f.field_name === 'photo_blue' || f.field_name === 'photo_white')" class="material-form-section">
				<div class="section-title">证件照</div>
				<div class="upload-row">
					<div class="upload-item">
						<van-uploader :after-read="(file) => uploadMaterialImage(file, 'cert_img')" max-count="1">
							<div class="upload-box large">
								<img v-if="materialFormData.cert_img" :src="materialFormData.cert_img"
									class="upload-preview" />
								<div v-else class="upload-placeholder">
									<van-icon name="plus" size="32" color="#999" />
									<span>上传证件照</span>
								</div>
							</div>
						</van-uploader>
					</div>
				</div>
			</div>

			<!-- 学历、工作信息 -->
			<div v-if="requiredFields.some(f => ['education_cert_primary', 'education_cert_senior', 'work_proof','old_cert'].includes(f.field_name))"
				class="material-form-section">
				<div class="section-title">职业信息</div>
				<div v-if="requiredFields.some(f => f.field_name === 'education_cert_primary' || f.field_name === 'education_cert_senior')" class="form-row">
					<div class="form-label">学历证明</div>
					<van-uploader :after-read="(file) => uploadMaterialImage(file, 'education_img')" max-count="1">
						<div class="upload-box">
							<img v-if="materialFormData.education_img" :src="materialFormData.education_img"
								class="upload-preview" />
							<van-icon v-else name="photograph" size="32" color="#999" />
						</div>
					</van-uploader>
				</div>
				<div class="form-row">
					<div class="form-label">工作单位</div>
					<van-field v-model="materialFormData.work_unit" placeholder="请输入工作单位" />
				</div>
				<div v-if="requiredFields.some(f => f.field_name === 'work_proof')" class="form-row">
					<div class="form-label">工作证明</div>
					<van-uploader :after-read="(file) => uploadMaterialImage(file, 'work_proof_img')" max-count="1">
						<div class="upload-box">
							<img v-if="materialFormData.work_proof_img" :src="materialFormData.work_proof_img"
								class="upload-preview" />
							<van-icon v-else name="photograph" size="32" color="#999" />
						</div>
					</van-uploader>
				</div>
				<div v-if="requiredFields.some(f => f.field_name === 'old_cert')" class="form-row">
					<div class="form-label">老证件</div>
					<van-uploader :after-read="(file) => uploadMaterialImage(file, 'old_cert_img')" max-count="1">
						<div class="upload-box">
							<img v-if="materialFormData.old_cert_img" :src="materialFormData.old_cert_img"
								class="upload-preview" />
							<van-icon v-else name="photograph" size="32" color="#999" />
						</div>
					</van-uploader>
				</div>
			</div>

			<div style="padding: 16px 0;">
				<van-button type="primary" block :loading="submittingMaterial" @click="submitMaterial">提交资料</van-button>
			</div>
		</div>
	</van-dialog>
</template>

<script setup>
	import {
		ref,
		reactive,
		computed,
		onMounted,
		watch,
		nextTick
	} from 'vue'
	import {
		showToast,
		showLoadingToast,
		closeToast
	} from 'vant'
	import axios from 'axios';
	import * as ww from '@wecom/jssdk'

	// 🔥 统一配置域名（只需要在这里改一次）
	const BASE_IMG_HOST = 'https://test1.zhuxinedu.com/'
	const BASE_URL = 'https://test1.zhuxinedu.com/api/'

	const showJdyPopup = ref(false)
	// TAB列表
	const tabList = ref([
		'咨询项目',
		'咨询工种',
		'新训复审查证',
		'客户性质',
		'报价情况',
		'客资质量',
		'是否返点',
		'地域信息'
	])
	const activeTabName = ref(0); // 0=第一个tab，1=第二个tab

	// 资料状态文本
	const getMaterialStatusText = (status) => {
		const map = {
			0: '收集中',
			1: '待审核',
			2: '已通过',
			3: '已拒绝'
		}
		return map[status] || '未知'
	}
	const getMaterialStatusClass = (status) => {
		const map = {
			0: 'status-collecting',
			1: 'status-pending',
			2: 'status-pass',
			3: 'status-reject'
		}
		return map[status] || ''
	}
	// 获取当前格式化时间
	const getNowTime = () => {
		const d = new Date()
		const year = d.getFullYear()
		const month = String(d.getMonth() + 1).padStart(2, '0')
		const day = String(d.getDate()).padStart(2, '0')
		const h = String(d.getHours()).padStart(2, '0')
		const m = String(d.getMinutes()).padStart(2, '0')
		const s = String(d.getSeconds()).padStart(2, '0')
		return `${year}-${month}-${day} ${h}:${m}:${s}`
	}

	const isfresh = ref(0); //是否强制刷新
	// 🔥 全局刷新整个页面
	const refreshEntirePage = () => {
		showToast('数据刷新中...')
		setTimeout(async () => {
			isfresh.value = 1;
			await checkCustomerExist()
		}, 500)
	}

	// 报名助手弹窗
	const order_class_options = ref([]) // 班级列表 [{ id, name }]
	const order_class_selected = ref('') // 选中的班级 id，空字符串表示暂不分班

	const showOrderFormDialog = ref(false)
	const order_user_name = ref('')
	const order_price = ref('')
	const order_componey = ref('筑信学校')
	const order_is_sign = ref('1')
	const order_bussines1 = ref('')
	const order_bussines2 = ref('')
	const order_bussines3_id = ref('')
	const order_bussines_type = ref('无')
	const order_radioOptions = ref([])
	const order_show_it3 = ref(false)
	const order_columns_data1 = ref([])
	const order_columns_data8 = ref([])
	const order_checked_value = ref({})

	// 设置学员告知书状态（互斥）
	const setSignStatus = (value) => {
		order_is_sign.value = value
	}
	const setPayeeStatus = (value) => {
		order_componey.value = value
	}

	const priceValidator = (val) => /^\d+(\.\d{1,2})?$/.test(val)
	// 打开订单表单
	const handleAddOrderOpen = () => {
		showOrderFormDialog.value = true
		getBussinesList()
	}

	// 获取业务类型
	async function getBussinesList() {
		try {
			const res = await axios.post(`${BASE_URL}staff_helper/get_bussines_choose_data`, {
				field: "yewu"
			})

			// ✅ 正确写法：你的接口是 res.data.data
			const list = res.data.data || []

			order_columns_data1.value = list.map(item => ({
				text: item,
				value: item
			}))

		} catch (err) {
			console.error('获取业务类型失败', err)
			order_columns_data1.value = []
		}
	}

	// 根据业务类型和工种获取班级列表
	const fetchClassList = async () => {
		const bussines = order_bussines1.value
		const gong = order_bussines2.value
		if (!bussines || !gong) {
			order_class_options.value = []
			order_class_selected.value = ''
			return
		}

		try {
			const res = await axios.post(`${BASE_URL}staff_helper/get_class_list`, {
				yewu: bussines,
				gong: gong
			})
			console.log(res, '获取可选分班信息')
			if (res.data.code === 1 && res.data.data) {
				order_class_options.value = res.data.data.map(item => ({
					id: item.class_code,
					name: item.class_name
				}))
			} else {
				order_class_options.value = []
			}
			// 重置选中的班级
			order_class_selected.value = ''
		} catch (err) {
			console.error('获取班级列表失败', err)
			order_class_options.value = []
		}
	}
	// 业务类型改变
	async function order_onBusinessChange() {
		order_bussines2.value = ''
		order_bussines3_id.value = ''
		order_price.value = ''
		order_bussines_type.value = '无'
		order_radioOptions.value = []
		order_show_it3.value = false

		const selected = order_columns_data1.value.find(item => item.text === order_bussines1.value)
		if (!selected) return

		const res = await axios.post(`${BASE_URL}staff_helper/get_jdy_entry_list`, {
			yewu: selected.value
		})

		// ✅ 这里也要改成 .data
		const data = res.data.data || []

		const list = data.map(item => ({
			text: item.gong,
			value: item.gong
		}))
		order_columns_data8.value = [...new Map(list.map(i => [i.value, i])).values()]

		fetchClassList()
	}

	// 工种改变
	async function order_onGongChange() {
		order_price.value = ''
		order_bussines3_id.value = ''
		order_bussines_type.value = '无'

		const selected = order_columns_data8.value.find(item => item.text === order_bussines2.value)
		if (!selected) return

		const res = await axios.post(`${BASE_URL}staff_helper/get_jdy_entry_list`, {
			yewu: order_bussines1.value,
			gong: selected.value
		})

		// ✅ 这里也改 .data
		const data = res.data.data || []

		const arr = data
			.map(item => ({
				id: item._id,
				label: item.type,
				value: item.price
			}))
			.filter(i => i.label !== '无')

		order_radioOptions.value = arr
		order_show_it3.value = arr.length > 0

		fetchClassList()
	}

	// 选择培训类型
	function order_chossed_value() {
		const selected = order_radioOptions.value.find(item => item.id === order_bussines3_id.value)
		if (!selected) {
			order_price.value = ''
			order_bussines_type.value = '无'
			order_checked_value.value = {}
			return
		}
		order_bussines_type.value = selected.label
		order_price.value = selected.value
		order_checked_value.value = selected
	}

	// 提交发送客户
	async function order_SentMessage() {
		if (!order_user_name.value || !order_bussines1.value || !order_bussines2.value || !order_price.value) {
			showToast('请完整填写')
			return
		}

		showLoadingToast({
			forbidClick: true
		})
		const order_id = new Date().toISOString().slice(0, 10) + Math.random().toString().slice(-5)

		try {
			await axios.post(`${BASE_URL}staff_helper/sent_reg_info`, {
				user_name: order_user_name.value,
				mobile: form.phone,
				price: order_price.value,
				bussines_type: order_bussines1.value,
				subject: order_bussines2.value,
				type: order_checked_value.value?.label || '无',
				componey: order_componey.value,
				is_sign: order_is_sign.value,
				external_userid: currentCustomer.external_userid,
				claim_id: localStorage.getItem('this_claim_id'),
				ww_user_id: localStorage.getItem('ww_user_id'),
				ww_user_name: localStorage.getItem('ww_user_name'),
				ww_department: localStorage.getItem('ww_department'),
				class_code: order_class_selected.value, // 新增：班级id，空字符串表示暂不分班
				class_name: order_class_selected.value ?
					order_class_options.value.find(c => c.id === order_class_selected.value)?.name : '',
				order_id
			})

			const {
				data: img
			} = await axios.post(`${BASE_URL}staff_helper/get_img`, {
				text: order_user_name.value + order_bussines1.value,
				amount: order_price.value
			})

			await ww.sendChatMessage({
				msgtype: 'miniprogram',
				miniprogram: {
					appid: 'wx9d24ac79c9372bf1',
					title: order_user_name.value + order_bussines1.value + order_bussines2.value + (
						order_checked_value.value?.label ||
						''),
					imgUrl: img,
					page: 'pages/index/index.html?order_id=' + order_id
				}
			})

			closeToast()
			showToast('订单发送成功 ✅')
			// ======================
			// ✅ 成功后清空所有表单
			// ======================
			order_user_name.value = ''
			order_price.value = ''
			order_componey.value = '1'
			order_bussines1.value = ''
			order_bussines2.value = ''
			order_bussines3_id.value = ''
			order_bussines_type.value = '无'
			order_radioOptions.value = []
			order_show_it3.value = false
			order_checked_value.value = {}
			// 成功后的清空
			order_class_selected.value = ''
			order_class_options.value = []

			showOrderFormDialog.value = false

			getOrderList();
		} catch (e) {
			closeToast()
			showToast('提交失败')
			console.error(e)
		}
	}

	// ====================== 线索编码自动弹窗 ======================
	// 弹窗切换标签 0=绑定老线索 1=新增客户
	const claimTab = ref(0)

	// 新增：是否存在客户资料（存在=显示全部标签，不存在=只显示跟进）
	const hasCustomerInfo = ref(false)

	const showClaimDialog = ref(false)
	const claimCode = ref('')
	const isClueChecked = ref(false)
	const claimLoading = ref(false)

	// 新客户表单
	const newCustomer = reactive({
		name: '',
		phone: '',
		wechat: '',
		source: '企业微信'
	})

	const corp_id = ref('')
	const agent_id = ref('')
	const we_redirect_uri = ref('')

	// 页面初始化 → 默认调用后台配置接口
	const initConfig = async () => {
		try {
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/init_config`, {})

			if (data.code === 1) {
				console.log('✅ 配置初始化成功', data.data)
				// 你后续需要存配置就放这里
				sourceList.value = data.data.customer_source
				projectList.value = data.data.consulting_project
				jobList.value = data.data.consulting_occupation
				trainList.value = data.data.type
				natureList.value = data.data.customer_nature
				priceList.value = data.data.quotation
				qualityList.value = data.data.lead_quality
				rebateList.value = data.data.rebate
				areaList.value = data.data.region

				corp_id.value = data.data.corp_id
				agent_id.value = data.data.agent_id
				we_redirect_uri.value = data.data.redirect_uri
			}
		} catch (err) {
			console.error('❌ 配置初始化失败', err)
		}
	}

	// 打开转换客户（简道云SSO）
	const openConvertCustomer = async () => {
		const ww_user_id = localStorage.getItem('ww_user_id')
		if (!ww_user_id) {
			showToast('请先登录')


			return
		}

		try {
			showLoadingToast({
				message: '正在打开...',
				forbidClick: true,
				duration: 0
			})


			const {
				data
			} = await axios.get(`${BASE_URL}jian_dao_yun/getSsoUrl`, {
				params: {
					ww_user_id,
				},
				withCredentials: true
			})

			closeToast()

			if (data.code === 1) {
				// 直接赋值到新窗口 → 100%能打开
				const a = document.createElement('a')
				a.target = '_blank'
				a.href = data.data.url
				a.click()
			} else {
				showToast(data.msg || '打开失败')
			}
		} catch (e) {
			closeToast()
			showToast('打开失败，请重试')
			console.error(e)
		}
	}

	const isSelf = ref(false) // 默认 false，后端返回后更新
	// ==============================================
	// 【新增】根据 unionid 查询线索是否已存在
	// ==============================================
	const checkCustomerExist = async () => {

		const ww_user_id = localStorage.getItem('ww_user_id')
		if (!ww_user_id) {
			showToast('请先登录')


			return
		}

		// 👇 打开加载中
		showLoadingToast({
			message: '加载中...',
			forbidClick: true,
			duration: 0
		})

		try {
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/default_customer_clue`, {
				ww_user_id: ww_user_id,
				unionid: currentCustomer.unionid,
				external_userid: currentCustomer.external_userid,
				isfresh: isfresh.value
			})

			closeToast()

			if (data.code === 1) {
				showToast('✅ 认领成功')

				localStorage.setItem('this_claim_code', data.data.claim.clue_coding)
				localStorage.setItem('this_claim_id', data.data.claim._id)
				localStorage.setItem('this_customer_name', data.data.claim.customer)
				localStorage.setItem('this_customer_phone', data.data.claim.number)

				if (data.data.customerInfo && data.data.customerInfo.jdy_customer_code !== null) {
					//如果存在客户
					if (data.data.customerInfo.jdy_customer_type == '个人') {
						form.name = data.data.customerInfo.name
						form.phone = data.data.customerInfo.phone
						editForm.name = data.data.customerInfo.name;
						editForm.phone = data.data.customerInfo.phone;

						form.classInfo = data.data.trainee.last_class_name || '未分班'
						form.status = data.data.trainee.zl_desc || '未收集'

					} else {
						//企业
						form.name = data.data.customerInfo.enterprise
						form.phone = data.data.customerInfo.phone
						editForm.name = data.data.customerInfo.enterprise;
						editForm.phone = data.data.customerInfo.phone;

						form.company = data.data.customerInfo.enterprise
					}

					form.source = data.data.claim.customer_source
					form.type = data.data.customerInfo.jdy_customer_type
					form.jdy_trainee_code = data.data.customerInfo.jdy_trainee_code
					form.owner = data.data.claim.person.name

					hasCustomerInfo.value = true;
				} else {
					form.name = data.data.claim.customer
					form.phone = data.data.claim.number
					editForm.name = data.data.claim.customer;
					editForm.phone = data.data.claim.number;

					form.source = data.data.claim.customer_source
					form.owner = data.data.claim.person.name
					hasCustomerInfo.value = false;
				}
				isSelf.value = data.data.isslef
				// 按英文逗号切成数组
				let claim_tags = data.data.claim.tags || ''
				form.tags = claim_tags.split(',').map(item => item.trim()).filter(Boolean)

				// 单选回显
				selectedNature.value = data.data.claim.customer_nature || ""
				selectedPrice.value = data.data.claim.quotation || ""
				selectedQuality.value = data.data.claim.lead_quality || ""
				selectedRebate.value = data.data.claim.rebate || ""
				selectedArea.value = data.data.claim.region || ""

				// 多选回显（数组格式，后端直接返数组）
				selectedProjects.value = data.data.claim.consulting_project || []
				selectedJobs.value = data.data.claim.consulting_occupation || []
				selectedTrains.value = data.data.claim.type || []

				isClueChecked.value = true
				showClaimDialog.value = false

				// 👇 认领成功 → 自动拉取跟进记录
				await getFollowRecordList()
				return true
			}

			showClaimDialog.value = true
			// 不存在 → 需要弹框
			return false
		} catch (err) {
			console.error('检查客户失败', err)
			return false
		}
	}

	// 统一提交（根据 tab 走不同逻辑）
	const handleSubmit = async () => {
		// 绑定老线索
		if (claimTab.value === 0) {
			await handleClaimOldCode()
			return
		}

		// 添加新客户
		await handleAddNewCustomer()
	}

	const handleClaimOldCode = async () => {
		const clue_code = claimCode.value?.trim()
		if (!clue_code) {
			showToast('请输入线索编码')
			return
		}

		const ww_user_id = localStorage.getItem('ww_user_id')
		if (!ww_user_id) {
			showToast('请先登录')


			return
		}
		showLoadingToast({
			message: '认领中...',
			forbidClick: true,
			duration: 0
		})
		try {
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/claim_clue`, {
				clue_code: clue_code,
				ww_user_id: ww_user_id,
				external_userid: currentCustomer.external_userid,
				openid: currentCustomer.openid || '',
				unionid: currentCustomer.unionid
			})
			closeToast()
			console.log(data, '返回值')

			// 失败：不关闭弹窗
			if (data.code === 0) {
				showToast(data.msg)
				return
			}

			// 成功：关闭弹窗
			if (data.code === 1) {
				showToast('✅ 认领成功')

				localStorage.setItem('this_claim_code', data.data.claim.clue_coding)
				localStorage.setItem('this_claim_id', data.data.claim._id)
				localStorage.setItem('this_customer_name', data.data.claim.customer)
				localStorage.setItem('this_customer_phone', data.data.claim.number)

				if (data.data.customerInfo && data.data.customerInfo.jdy_customer_code !== null) {
					//如果存在客户
					if (data.data.customerInfo.jdy_customer_type == '个人') {
						form.name = data.data.customerInfo.name
						form.phone = data.data.customerInfo.phone
						editForm.name = data.data.customerInfo.name;
						editForm.phone = data.data.customerInfo.phone;

						form.classInfo = data.data.trainee.last_class_name || '未分班'
						form.status = data.data.trainee.zl_desc || '未收集'
					} else {
						//企业
						form.name = data.data.customerInfo.enterprise
						form.phone = data.data.customerInfo.phone
						editForm.name = data.data.customerInfo.enterprise;
						editForm.phone = data.data.customerInfo.phone;

						form.company = data.data.customerInfo.enterprise
					}

					form.owner = data.data.claim.person.name
					form.source = data.data.claim.customer_source
					form.type = data.data.customerInfo.jdy_customer_type

					hasCustomerInfo.value = true;
				} else {
					form.name = data.data.claim.customer
					form.phone = data.data.claim.number
					editForm.name = data.data.claim.customer;
					editForm.phone = data.data.claim.number;

					form.owner = data.data.claim.person.name
					form.source = data.data.claim.customer_source
					hasCustomerInfo.value = false;
				}

				isSelf.value = data.data.isslef
				// 按英文逗号切成数组
				let claim_tags = data.data.claim.tags || ''
				form.tags = claim_tags.split(',').map(item => item.trim()).filter(Boolean)

				// 单选回显
				selectedNature.value = data.data.claim.customer_nature || ""
				selectedPrice.value = data.data.claim.quotation || ""
				selectedQuality.value = data.data.claim.lead_quality || ""
				selectedRebate.value = data.data.claim.rebate || ""
				selectedArea.value = data.data.claim.region || ""

				// 多选回显（数组格式，后端直接返数组）
				selectedProjects.value = data.data.claim.consulting_project || []
				selectedJobs.value = data.data.claim.consulting_occupation || []
				selectedTrains.value = data.data.claim.type || []

				isClueChecked.value = true
				showClaimDialog.value = false

				// 👇 认领成功 → 自动拉取跟进记录
				await getFollowRecordList()
			}
		} catch (err) {
			closeToast()
			showToast('提交失败，请重试')
		}
	}
	// ====================
	// 2添加新客户
	// ====================
	const handleAddNewCustomer = async () => {
		const {
			name,
			phone,
			wechat,
			source
		} = newCustomer

		if (!name) return showToast('请输入客户名称')

		const ww_user_id = localStorage.getItem('ww_user_id')
		if (!ww_user_id) {
			showToast('请先登录')
			return
		}

		showLoadingToast({
			message: '加载中...',
			forbidClick: true,
			duration: 0
		})

		try {
			// === 这里替换成你的新增客户接口 ===
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/add_customer_clue`, {
				name,
				phone,
				wechat,
				source,
				ww_user_id,
				external_userid: currentCustomer.external_userid || '',
				openid: currentCustomer.openid || '',
				unionid: currentCustomer.unionid || ''
			})

			closeToast()

			// 成功：关闭弹窗
			if (data.code === 1) {
				showToast('✅ 创建新线索成功')

				setTimeout(async () => {
					isfresh.value = 1;
					await checkCustomerExist()
				}, 200)
			} else {
				showToast(data.msg)
				return
			}
		} catch (err) {
			closeToast()
			showToast('提交失败，请重试')
		}
	}

	// 客户信息
	const form = reactive({
		name: '',
		type: '',
		phone: '',
		company: '',
		classInfo: '',
		status: '',
		source: '',
		owner: '',
		colleagues: '',
		jdy_trainee_code: '',
		tags: []
	})

	// 编辑弹窗
	const showEditDialog = ref(false)
	const editForm = reactive({
		...form
	})

	// 跟进记录
	const followRecords = ref([])
	const showAddRecordDialog = ref(false)

	const submitting = ref(false)

	const addForm = ref({
		content: ''
	})

	// 标签弹窗
	const showTagDialog = ref(false)

	// 客户来源 单独弹窗
	const showSourceDialog = ref(false)

	//分班信息 单独弹窗
	const showClassDialog = ref(false)
	
	// 打开分班窗口
	const handleUpdateClassOpen = () => {
		showClassDialog.value = true
		getBussinesList()
	}

	// 单选选中值
	const selectedSource = ref('')
	const selectedNature = ref('')
	const selectedPrice = ref('')
	const selectedQuality = ref('')
	const selectedRebate = ref('')
	const selectedArea = ref('')

	// 多选选中值
	const selectedProjects = ref([])
	const selectedJobs = ref([])
	const selectedTrains = ref([])

	// 下拉选项示例（你可以自己改）
	const sourceList = ref([])
	const projectList = ref([])
	const jobList = ref([])
	const trainList = ref([])
	const natureList = ref([])
	const priceList = ref([])
	const qualityList = ref([])
	const rebateList = ref([])
	const areaList = ref([])

	// 打开时自动回显
	watch(showSourceDialog, (val) => {
		if (val) selectedSource.value = form.source || ''
	})

	// 🔥 通用：单选 checkbox（点击选中，再次点击取消）
	const handleSingleCheck = (type, val, e) => {
		let target = null
		// 绑定你对应的变量
		if (type === 'nature') target = selectedNature
		if (type === 'price') target = selectedPrice
		if (type === 'quality') target = selectedQuality
		if (type === 'rebate') target = selectedRebate
		if (type === 'area') target = selectedArea

		// 已经选中 → 取消
		if (target.value === val) {
			e.target.checked = false
			target.value = ''
		}
		// 未选中 → 选中，并清空同组其他
		else {
			target.value = val
		}
	}

	//保存班级信息
	const handleClassConfirm = async () => {

		if (!order_bussines1.value || !order_bussines2.value || !order_class_selected.value) {
			showToast('请完整选择班级信息')
			return
		}

		showLoadingToast({
			message: '保存中...',
			forbidClick: true,
			duration: 0
		})

		try {
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/update_class`, {
				jdy_trainee_code: form.jdy_trainee_code,
				bussines_type: order_bussines1.value,
				subject: order_bussines2.value,
				class_code: order_class_selected.value, // 新增：班级id，空字符串表示暂不分班
				class_name: order_class_selected.value ?
					order_class_options.value.find(c => c.id === order_class_selected.value)?.name : ''
			})

			closeToast()

			if (data.code === 1) {
				showToast('分班信息保存成功')
			} else {
				showToast(data.msg || '保存失败')
			}
		} catch (err) {
			closeToast()
			showToast('保存失败，请重试')
			console.error(err)
		}

		showClassDialog.value = false
	}

	// 保存客户来源
	const handleSourceConfirm = async () => {
		if (!selectedSource.value) {
			showToast('请选择客户来源')
			return
		}

		const ww_user_id = localStorage.getItem('ww_user_id')
		const subject = localStorage.getItem('this_claim_id')
		if (!ww_user_id || !subject) {
			showToast('信息缺失，无法保存')
			return
		}

		// 获取当前已有的标签数据（从临时变量中获取，这些变量已在 checkCustomerExist 中赋值）
		const postData = {
			customer_nature: selectedNature.value || '',
			quotation: selectedPrice.value || '',
			lead_quality: selectedQuality.value || '',
			rebate: selectedRebate.value || '',
			region: selectedArea.value || '',
			consulting_project: selectedProjects.value || [],
			consulting_occupation: selectedJobs.value || [],
			type: selectedTrains.value || []
		}

		console.log('提交的22 postData:', postData)
		// 新的 tags 数组：新的来源 + 原有的其他标签
		const newTags = [
			selectedSource.value,
			selectedNature.value,
			selectedPrice.value,
			selectedQuality.value,
			selectedRebate.value,
			selectedArea.value,
			...selectedProjects.value,
			...selectedJobs.value,
			...selectedTrains.value
		].filter(Boolean)

		showLoadingToast({
			message: '保存中...',
			forbidClick: true,
			duration: 0
		})

		try {
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/update_clue_tags`, {
				ww_user_id,
				subject,
				tags: newTags,
				customer_source: selectedSource.value,
				...postData
			})

			closeToast()
			if (data.code === 1) {
				showToast('来源保存成功')
				form.source = selectedSource.value
				form.tags = newTags
				showSourceDialog.value = false
			} else {
				showToast(data.msg || '保存失败')
			}
		} catch (err) {
			closeToast()
			showToast('保存失败，请重试')
			console.error(err)
		}
	}

	// 保存客户标签
	const handleTagConfirm = async () => {
		// 构造标签数据（不包含 customer_source 字段，但 tags 数组中需要包含当前来源）
		const postData = {
			customer_nature: selectedNature.value || '',
			quotation: selectedPrice.value || '',
			lead_quality: selectedQuality.value || '',
			rebate: selectedRebate.value || '',
			region: selectedArea.value || '',
			consulting_project: selectedProjects.value || [],
			consulting_occupation: selectedJobs.value || [],
			type: selectedTrains.value || []
		}
		console.log('提交的11 postData:', postData)
		// tags 数组必须包含来源字段（使用当前表单中的来源，而不是 selectedSource）
		const currentSource = form.source // 🔥 关键：用当前实际来源
		const tags = [
			currentSource,
			selectedNature.value,
			selectedPrice.value,
			selectedQuality.value,
			selectedRebate.value,
			selectedArea.value,
			...selectedProjects.value,
			...selectedJobs.value,
			...selectedTrains.value
		].filter(Boolean)

		const ww_user_id = localStorage.getItem('ww_user_id')
		const subject = localStorage.getItem('this_claim_id')
		if (!ww_user_id || !subject) {
			showToast('信息缺失，无法保存')
			return
		}

		showLoadingToast({
			message: '保存中...',
			forbidClick: true,
			duration: 0
		})

		try {
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/update_clue_tags`, {
				ww_user_id,
				subject,
				tags: tags,
				customer_source: currentSource, // 显式传递当前来源
				...postData
			})

			closeToast()
			if (data.code === 1) {
				showToast('标签保存成功')
				form.tags = tags
				// 保持 form.source 不变（已经是最新）
				showTagDialog.value = false
			} else {
				showToast(data.msg || '保存失败')
			}
		} catch (err) {
			closeToast()
			showToast('保存失败，请重试')
			console.error(err)
		}
	}
	// 移除标签
	const removeTag = (tag) => {
		const index = form.tags.indexOf(tag)
		if (index > -1) {
			form.tags.splice(index, 1)
		}
	}

	// 编辑客户信息确认保存
	const handleEditConfirm = async () => {
		// 必传校验
		if (!editForm.name?.trim()) {
			showToast('请输入姓名');
			return;
		}

		// 加载中
		showLoadingToast({
			message: '保存中...',
			forbidClick: true,
			duration: 0
		});

		try {
			const ww_user_id = localStorage.getItem('ww_user_id');
			const subject = localStorage.getItem('this_claim_id');

			if (!ww_user_id || !subject) {
				closeToast();
				showToast('用户信息缺失，请重新进入');
				return;
			}

			// 发送后端接口
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/update_customer_info`, {
				ww_user_id,
				subject,
				external_userid: currentCustomer.external_userid,
				name: editForm.name.trim(),
				phone: editForm.phone.trim(),
				// // 有资料时才传单位和班级
				// company: hasCustomerInfo.value ? (editForm.company?.trim() || '') : '',
				// classInfo: hasCustomerInfo.value ? (editForm.classInfo?.trim() || '') : '',
			});

			closeToast();

			if (data.code === 1) {
				showToast('保存成功 ✅');

				// 同步更新页面显示的数据
				form.name = editForm.name;
				form.phone = editForm.phone;
				// if (hasCustomerInfo.value) {
				// 	form.company = editForm.company;
				// 	form.classInfo = editForm.classInfo;
				// }

				// 关闭弹窗
				showEditDialog.value = false;
			} else {
				showToast(data.msg || '保存失败');
			}
		} catch (err) {
			closeToast();
			showToast('网络异常，保存失败');
			console.error('编辑保存失败：', err);
		}
	};

	// 获取客户跟进记录列表
	const getFollowRecordList = async () => {

		const clue_code = localStorage.getItem('this_claim_code')
		if (!clue_code) {
			showToast('请输入线索编码')
			return
		}
		const ww_user_id = localStorage.getItem('ww_user_id')
		if (!ww_user_id) {
			showToast('请先登录')


			return
		}

		// 打开 loading
		showLoadingToast({
			message: '加载中...',
			forbidClick: true,
			duration: 0
		})

		try {
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/follow_list`, {
				clue_code: clue_code,
				ww_user_id: ww_user_id
			})

			// 关闭 loading
			closeToast()

			if (data.code === 1 && data.data) {
				// 接口返回记录 → 覆盖到页面列表
				followRecords.value = data.data
			}
		} catch (err) {
			closeToast()
			console.error('获取跟进记录失败', err)
		}
	}

	// 监听添加跟进记录弹窗关闭，重置提交状态
	watch(showAddRecordDialog, (newVal) => {
		if (!newVal) {
			// 弹窗关闭时重置提交状态和表单内容（可选）
			submitting.value = false
			addForm.value.content = ''
		}
	})

	// 添加跟进记录
	const handleAddRecord = async () => {

		// 1. 如果正在提交，直接拦截
		if (submitting.value) return

		// 👇 加固：addForm 不存在直接 return
		if (!addForm.value) {
			addForm.value = {
				content: ''
			}
			return
		}

		// 1. 非空校验
		if (!addForm.value.content?.trim()) {
			showToast('请输入跟进内容')
			return
		}

		const ww_user_id = localStorage.getItem('ww_user_id')
		if (!ww_user_id) {
			showToast('请先登录')
			return
		}

		// 2. 打开 loading
		showLoadingToast({
			message: '提交中...',
			forbidClick: true,
			duration: 0
		})

		// 🔥 上锁：开始提交
		submitting.value = true

		try {
			// 3. 调用后端接口
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/add_follow_record`, {
				clue_code: localStorage.getItem('this_claim_code'),
				customer_name: localStorage.getItem('this_customer_name'),
				subject: localStorage.getItem('this_claim_id'),
				content: addForm.value.content.trim(),
				ww_user_id: ww_user_id,
				openid: currentCustomer.openid || '',
				unionid: currentCustomer.unionid || ''
			})

			// 4. 关闭 loading
			closeToast()

			// 5. 后端返回成功
			if (data.code === 1) {
				showToast('添加成功')
				addForm.value.content = ''
				showAddRecordDialog.value = false

				// 🔥 只保留这一句：重新拉取最新列表（自动去重）
				await getFollowRecordList()
			} else {
				showToast(data.msg || '添加失败')
			}
		} catch (err) {
			closeToast()
			showToast('提交失败，请重试')
			console.error('添加跟进记录失败：', err)
		} finally {
			submitting.value = false // 🔥 关键：重置提交状态
		}
	}

	// ==================== 资料收集弹窗 ====================
	const showMaterialDialog = ref(false) // 资料收集弹窗开关
	const materialOrderList = ref([]) // 订单及资料列表
	const currentMaterialOrder = ref(null) // 当前正在编辑的订单
	const showMaterialFormDialog = ref(false) // 资料表单弹窗
	const materialFormData = reactive({
		id_front: '', // 身份证正面
		id_back: '', // 身份证反面
		cert_img: '', // 证件照
		education_img: '', // 学历证明
		work_unit: '', // 工作单位
		work_proof_img: '', // 工作证明
		old_cert_img: '', // 老证件（复训）
		signature_img: '' // 电子签名（可选，如果需要）
	})
	const requiredFields = ref([]) // 当前订单需要的字段列表
	const submittingMaterial = ref(false)

	// 获取学员的报名订单及资料状态
	const getMaterialOrderList = async () => {
		const external_userid = currentCustomer.external_userid
		if (!external_userid) {
			showToast('未获取到客户信息')
			return
		}
		showLoadingToast({
			message: '加载中...',
			forbidClick: true
		})
		try {
			// 假设后端接口：获取学员所有订单及所需资料完成情况
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/get_material_list`, {
				external_userid,
				jdy_trainee_code: form.jdy_trainee_code
			})
			closeToast()
			if (data.code === 1 && data.data) {
				materialOrderList.value = data.data
				showMaterialDialog.value = true
			} else {
				showToast(data.msg || '暂无报名订单')
			}
		} catch (err) {
			closeToast()
			showToast('加载失败')
		}
	}

	// 打开资料表单（用于补充/查看资料）
	const openMaterialForm = async (order) => {
		currentMaterialOrder.value = order
		// 根据订单的 course_cate 获取所需字段列表
		await fetchRequiredFields(order.course_cate)
		// 加载已上传的资料（如果有）
		await loadMaterialData(order.course_cate)
		showMaterialFormDialog.value = true
	}

	// 获取所需字段列表
	const fetchRequiredFields = async (courseCate) => {
		const external_userid = currentCustomer.external_userid
		if (!external_userid) {
			showToast('未获取到客户信息')
			return
		}
		try {
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/get_required_fields`, {
				external_userid,
				course_cate: courseCate,
				is_review: false
			})
			console.log(data,'需要资料返回')
			requiredFields.value = data.data || []
		} catch (err) {
			console.error('获取字段失败', err)
			requiredFields.value = []
		}
	}

	// 加载已上传的资料数据
	const loadMaterialData = async (courseCate) => {
		const external_userid = currentCustomer.external_userid
		if (!external_userid) {
			showToast('未获取到客户信息')
			return
		}
		try {
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/get_material_data`, {
				external_userid,
				course_cate: courseCate,
			})
			console.log(data.data,'获取资料信息返回')
			if (data.code === 1 && data.data) {
				Object.assign(materialFormData, data.data)
			} else {
				// 清空表单
				Object.keys(materialFormData).forEach(key => materialFormData[key] = '')
			}
		} catch (err) {
			console.error('加载资料失败', err)
		}
	}

	// 上传图片通用方法
	const uploadMaterialImage = async (file, type) => {
		// 这里需要将图片转为base64或使用formData上传
		// 由于侧边栏环境，可以使用van-uploader组件的after-read
		// 简单实现：使用axios上传
		const formData = new FormData()
		formData.append('file', file.file)
		formData.append('type', type)
		try {
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/upload_material`, formData)
			if (data.code === 1) {
				materialFormData[type] = data.data.url
				showToast('上传成功')
			} else {
				showToast('上传失败')
			}
		} catch (err) {
			showToast('上传失败')
		}
	}

	// 提交资料
	const submitMaterial = async () => {
		const external_userid = currentCustomer.external_userid
		if (!external_userid) {
			showToast('未获取到客户信息')
			return
		}
		if (submittingMaterial.value) return
		// 校验必填字段
		const missing = []
		requiredFields.value.forEach(field => {
			if (field.required && !materialFormData[field.field_name]) {
				missing.push(field.field_label)
			}
		})
		if (missing.length) {
			showToast(`请填写/上传：${missing.join('、')}`)
			return
		}
		submittingMaterial.value = true
		showLoadingToast({
			message: '提交中...',
			forbidClick: true
		})
		try {
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/submit_material`, {
				external_userid,
				material_data: materialFormData,
				required_fields: requiredFields.value
			})
			closeToast()
			if (data.code === 1) {
				showToast('资料提交成功')
				showMaterialFormDialog.value = false
				// 刷新订单列表状态
				await getMaterialOrderList()
			} else {
				showToast(data.msg || '提交失败')
			}
		} catch (err) {
			closeToast()
			showToast('提交失败')
		} finally {
			submittingMaterial.value = false
		}
	}

	// 标签页
	const activeTab = ref(0)

	const nowTime = ref('')

	// 监听标签页切换，点击到【开班】时加载
	watch(activeTab, (newTab) => {
		// 先定义好变量，再赋值 → 解决作用域问题
		let tabTitles = []

		// 根据客户信息判断标题数组
		if (hasCustomerInfo.value) {
			if (form.type == '个人') {
				tabTitles = ['跟进', '订单', '学情', '开班', '雷达', '工具']
			} else {
				tabTitles = ['跟进', '订单', '学员', '开班', '雷达', '工具']
			}
		} else {
			tabTitles = ['跟进', '订单', '开班']
		}

		// 获取当前标题
		const currentTitle = tabTitles[newTab]
		console.log('当前切换到：', currentTitle)
		// 根据名称判断
		if (currentTitle === '订单') {
			getOrderList()
		}
		if (currentTitle === '学员') {
			getGradeList()
		}
		if (currentTitle === '开班') {
			nowTime.value = getNowTime()
			getClassList()
		}
	})

	//学员
	const gradeList = ref([]) // 班级列表
	// 学员TAB索引
	const studentActiveTab = ref(0)

	// 🔥 自动根据TAB过滤学员列表（核心）
	const filteredStudentList = computed(() => {
		// 对应：0待报名 1待分班 2已在班
		const statusMap = ['待报名', '待分班', '已在班']
		const currentStatus = statusMap[studentActiveTab.value]
		console.log(currentStatus, '状态')
		// 过滤你的学员列表（根据 fb_desc / 状态字段匹配）
		return gradeList.value.filter(item => {
			// 这里用你的状态字段匹配，我用 fb_desc 做示例
			return item.fb_desc === currentStatus
		})
	})

	// 获取班级列表
	const getGradeList = async () => {

		const ww_user_id = localStorage.getItem('ww_user_id')
		if (!ww_user_id) {
			showToast('请先登录')


			return
		}

		showLoadingToast({
			message: '加载班级中...',
			forbidClick: true,
			duration: 0
		})

		try {
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/grade_list`, {
				ww_user_id,
				external_userid: currentCustomer.external_userid,
			})

			closeToast()
			if (data.code === 1 && data.data) {
				gradeList.value = data.data
			} else {
				gradeList.value = []
			}
		} catch (err) {
			closeToast()
			console.error('获取班级失败', err)
			showToast('班级加载失败')
		}
	}

	//订单
	const orderList = ref([]) // 订单列表
	const showAddOrderDialog = ref(false) // 添加订单弹窗
	// 开票按钮loading状态
	const invoicingOrderId = ref('')

	// 获取订单列表
	const getOrderList = async () => {

		const ww_user_id = localStorage.getItem('ww_user_id')
		if (!ww_user_id) {
			showToast('请先登录')
			return
		}

		showLoadingToast({
			message: '加载订单中...',
			forbidClick: true,
			duration: 0
		})

		try {
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/order_list`, {
				ww_user_id,
				external_userid: currentCustomer.external_userid,
			})

			closeToast()
			if (data.code === 1 && data.data) {
				// 确保每个订单有 invoice_status 字段，默认0未开票
				orderList.value = data.data.map(item => ({
					...item,
					invoice_status: item.invoice_status !== undefined ? item.invoice_status : 0
				}))
			} else {
				orderList.value = []
			}
		} catch (err) {
			closeToast()
			console.error('获取订单失败', err)
			showToast('订单加载失败')
		}
	}

	// 开票处理函数
	const handleInvoice = async (order) => {
		// 防止重复点击
		if (invoicingOrderId.value) return

		const ww_user_id = localStorage.getItem('ww_user_id')
		if (!ww_user_id) {
			showToast('请先登录')
			return
		}

		invoicingOrderId.value = order.order_id
		showLoadingToast({
			message: '开票处理中...',
			forbidClick: true,
			duration: 0
		})

		try {
			const {
				data
			} = await axios.post(`${BASE_URL}invoicing/encryptParam`, {
				order_num: order.order_id
			})
			console.log(data, '开票返回')

			closeToast()
			if (data.code === 1) {
				showToast('开票分享生成成功 ✅')
				await ww.sendChatMessage({
					msgtype: 'miniprogram',
					miniprogram: {
						appid: 'wx9d24ac79c9372bf1',
						title: '开票申请',
						imgUrl: BASE_IMG_HOST + 'static/img/invoice_apply.jpeg',
						page: 'packages/pages/order/invoice?encrypt=' + data.data.encrypted
					}
				})
			} else {
				showToast(data.msg || '开票失败，请重试')
			}
		} catch (err) {
			closeToast()
			console.error('开票失败', err)
			showToast('开票失败，请检查网络')
		} finally {
			invoicingOrderId.value = ''
		}
	}

	//学情
	const mockExams = ref([])

	//开班
	const classList = ref([])
	// 开班搜索
	const searchKeyword = ref('') // 搜索关键词
	// 过滤后的开班列表
	const filteredClassList = computed(() => {
		if (!searchKeyword.value) return classList.value
		const kw = searchKeyword.value.trim()
		if (!kw) return classList.value
		return classList.value.filter(item => item.class_name && item.class_name.includes(kw))
	})
	// ==============================
	// 获取 开班信息（后端接口）
	// ==============================
	const getClassList = async () => {

		const ww_user_id = localStorage.getItem('ww_user_id')
		if (!ww_user_id) {
			showToast('请先登录')
			return
		}

		showLoadingToast({
			message: '加载中...',
			forbidClick: true,
			duration: 0
		})

		try {
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/class_list`, {
				ww_user_id
			})

			closeToast()

			if (data.code === 1 && data.data?.length > 0) {
				// 接口返回数据 → 自动渲染到页面
				classList.value = data.data
			} else {
				classList.value = []
				// showToast('暂无开班计划')
			}
		} catch (err) {
			closeToast()
			console.error('获取开班信息失败：', err)
			showToast('开班信息加载失败')
		}
	}

	// 刷新开班列表
	const refreshClassList = () => {
		classList.value = []
		nowTime.value = getNowTime()
		getClassList()
		searchKeyword.value = '' // 清空搜索框
		showToast('刷新成功 ✅')
	}
	//雷达
	const radarList = ref([])

	//工具
	const toolTabActive = ref(0)
	const toolGroups = ref([])
	const handleToolClick = (item) => showToast(`打开: ${item.name}`)

	// ==============================================
	// 企业微信登录 + 发送消息
	// ==============================================
	const user_name = ref('')
	const price = ref('')
	const componey = ref('1')
	const can_edit = ref(true)
	const subtract = ref(0)
	const checked_value = ref([])
	const bussines1 = ref('')
	const bussines2 = ref('')
	const bussines_type = ref('无')
	const radioOptions = ref([])
	const pickerValue1 = ref([])
	const pickerValue2 = ref([])
	const show_it1 = ref(false)
	const show_it2 = ref(false)
	const show_it3 = ref(false)
	const isLoggedIn = ref(false)

	const pattern = /[\u4E00-\u9FA5]/
	const validator = (val) => /^\d+(\.\d{1,2})?$/.test(val)

	// 登录检查
	const checkLogin = () => {
		const userId = localStorage.getItem('ww_user_id')
		isLoggedIn.value = !!userId
	}

	// 跳转企业微信登录
	const goWxLogin = () => {
		const CORP_ID = corp_id.value
		const redirect_uri = encodeURIComponent(we_redirect_uri.value)
		const url =
			`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${CORP_ID}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
		console.log(url, '授权跳转链接')
		window.location.href = url
	}
	// ==============================================
	// 企业微信侧边栏：自动获取当前对话客户 external_userid
	// ==============================================
	const currentCustomer = reactive({
		external_userid: '',
		openid: '',
		unionid: ''
	})

	// 自动获取当前客户 ID
	const getCurrentCustomer = async () => {
		try {
			const res = await ww.getCurExternalContact()
			const external_userid = res.userId
			currentCustomer.external_userid = external_userid
			console.log('✅ 客户 external_userid：', external_userid)
			getCustomerUnionId(external_userid)
		} catch (err) {
			console.log('未获取到客户（非客户聊天）')
		}
	}

	// 通过后端接口获取 openid + unionid
	const getCustomerUnionId = async (external_userid) => {
		try {
			const {
				data
			} = await axios.post(`${BASE_URL}staff_helper/get_customer_unionid`, {
				external_userid
			})

			newCustomer.name = data.data.name || ''
			currentCustomer.openid = data.data.openid || ''
			currentCustomer.unionid = data.data.unionid || ''

			await checkCustomerExist()

			console.log('✅ 客户信息：', currentCustomer)
		} catch (err) {
			console.error('获取客户unionid失败')
		}
	}

	// 获取 code 登录
	const getCodeFromUrl = async () => {
		const urlParams = new URLSearchParams(window.location.search)
		const code = urlParams.get('code')

		console.log("=== 当前 code =", code) // 你会在控制台看到

		if (!code) {
			console.log("=== 无 code，需要跳转登录 ===")
			return
		}
		//先清除code
		window.history.replaceState({}, document.title, window.location.pathname)

		try {
			console.log("=== 开始用 code 登录 ===")
			const res = await axios.post(`${BASE_URL}staff_helper/ww_get_user_info`, {
				code
			})

			console.log("=== 返回值 ===")
			console.log("=== 员工信息 ===", res)
			console.log("=== 返回值 ===")
			if (res.data.code === 1) {
				localStorage.setItem('ww_user_id', res.data.data.ww_user_id)
				localStorage.setItem('ww_user_name', res.data.data.ww_user_name)
				localStorage.setItem('ww_department', res.data.data.ww_department)
				isLoggedIn.value = true
				console.log("=== 登录成功，用户ID：", res.data.data.ww_user_id)
				showToast('登录成功')
				// 登录完成 → 初始化企业微信配置
				await initWxConfig()
			}
		} catch (err) {
			console.error("登录失败", err)
			showToast('登录失败')
		}
	}

	// 初始化企业微信 JSSDK
	const initWxConfig = async () => {
		try {
			if (!ww) {
				console.error('❌ 企业微信SDK加载失败')
				return
			}

			await ww.register({
				corpId: corp_id.value,
				agentId: agent_id.value,
				jsApiList: ['sendChatMessage', 'getCurExternalContact'],

				async getAgentConfigSignature() {
					try {
						const url = window.location.href.split('#')[0];
						const {
							data
						} = await axios.get(
							`${BASE_URL}staff_helper/get_agent_signature`, {
								params: {
									url
								}
							})
						return {
							timestamp: data.data.timestamp,
							nonceStr: data.data.noncestr,
							signature: data.data.signature
						}
					} catch (err) {
						showToast('获取签名失败:' + JSON.stringify(err))
						throw err
					}
				},
				onAgentConfigSuccess: () => {
					console.log('✅ 企业微信配置成功')
					getCurrentCustomer()
				},
				onAgentConfigFail: (err) => {
					showToast('配置失败:' + JSON.stringify(err))
				}
			})
		} catch (e) {
			console.error('初始化失败', e)
		}
	}

	// 页面加载时执行
	onMounted(async () => {

		// ✅ 页面加载 → 自动调用后台配置接口
		await initConfig()

		// 👇 强制执行！不管有没有 code，一定跑！
		await getCodeFromUrl()

		// 第一步：检查本地有没有登录信息
		checkLogin()

		// 第二步：如果本地没有 → 强制跳企业微信静默登录
		if (!isLoggedIn.value) {
			console.log("=== 未登录，开始跳转静默登录 ===")
			goWxLogin()
			return
		} else {
			// 第三步：已登录 → 继续初始化
			console.log("=== 已登录，继续初始化 ===")
			await initWxConfig()
		}
	})
</script>

<style scoped>
	/* ===== 字体统一与企业微信侧边栏一致（除标题外） ===== */
	.container,
	.only-follow {
		font-size: 14px;
		display: flex;
		flex-direction: column;
		height: 100vh;
		overflow-y: auto;
		/* 让整个容器滚动，而不是内部 tabs 滚动 */
	}

	/* 恢复所有标题类字体大小 */
	.card-title,
	.record-title,
	.class-title,
	.radar-title,
	.tool-name,
	.exam-title,
	.order-card-header .order-no,
	.customer-card .card-title,
	.class-name,
	.order-no {
		font-size: inherit;
	}

	/* 已认领卡片标题 */
	.customer-card.claimed .card-title {
		font-size: 22px;
	}

	/* 未认领卡片标题 */
	.customer-card.unclaimed .card-title {
		font-size: inherit;
	}

	/* 跟进记录标题 */
	.record-title {
		font-size: inherit;
	}

	/* 开班标题 */
	.class-title {
		font-size: inherit;
	}

	/* 雷达标题 */
	.radar-title {
		font-size: 20px;
	}

	/* 工具名称 */
	.tool-name {
		font-size: inherit;
	}

	/* 学情区块标题 */
	.exam-title {
		font-size: inherit;
	}

	/* 订单号保持原有大小 */
	.order-card-header .order-no {
		font-size: inherit;
	}

	/* 班级名称保持稍大 */
	.class-name {
		font-size: inherit;
		font-weight: 600;
	}

	/* 全局基础样式 - 全屏幕完美适配 */
	* {
		box-sizing: border-box;
		max-width: 100%;
	}

	html,
	body {
		margin: 0;
		padding: 0;
	}

	page,
	body,
	#app {
		width: 100%;
		min-height: 100vh;
		margin: 0;
		padding: 0;
	}

	.container,
	.only-follow {
		display: flex;
		flex-direction: column;
		height: 100vh;
		/* 占满整个视口高度 */
		overflow: hidden;
		/* 禁止外层滚动 */
		width: 100%;
	}

	/* 🔥 全局顶部刷新条 - 美观、协调、不突兀 */
	.global-refresh-bar {
		width: 100%;
		padding: 10px 16px;
		background: #f7f8fa;
		color: #1677ff;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		font-size: 14px;
		cursor: pointer;
		border-bottom: 1px solid #eee;
	}

	.global-refresh-bar:active {
		background: #e8f3ff;
	}

	/* 以下是你原来的所有样式，我已经全部优化适配完毕 */
	.pc-select {
		width: 100%;
		padding: 8px 12px;
		border: 1px solid #eee;
		border-radius: 6px;
		font-size: 15px;
		outline: none;
		background: #fff;
	}

	.pc-select:focus {
		border-color: #1989fa;
	}

	.no-arrow {
		appearance: none;
		-webkit-appearance: none;
		background-image: none;
	}

	.tags-select {
		padding: 8px 12px;
		border: 1px solid #eee;
		border-radius: 8px;
		width: 100%;
		min-width: 200px;
		font-size: 14px;
	}

	.claim-code {
		border: 1px solid #e5e7eb;
		border-radius: 12px;
		padding: 10px 14px;
		background: #f9fafb;
		width: 90%;
		margin-left: 5%;
	}

	.only-follow {
		padding-top: 20px;
		background: #fff;
		min-height: 100vh;
	}

	.container {
		min-height: 100vh;
		background-color: #f5f5f5;
	}

	/* 全新商务卡片样式 */
	/* ========== 客户卡片通用样式 ========== */
	.customer-card {
		padding: 20px;
		flex-shrink: 0;
		/* 不参与压缩，保持原始高度 */
	}

	/* 让 van-tabs 组件占满剩余高度，并改为 flex 列布局 */
	.van-tabs {
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	/* 让 tabs 的内容区域可滚动（关键） */
	:deep(.van-tabs__content) {
		flex: 1;
		overflow-y: auto;
	}

	/* ========== 认领状态卡片（深色渐变商务风） ========== */
	.customer-card.claimed {
		background: linear-gradient(135deg, #5a90f1 0%, #5487df 100%);
		color: #fff;
		box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.2), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
		width: 100%;
		position: sticky;
		top: 0;
		left: 0;
		right: 0;
		z-index: 20;
		box-sizing: border-box;
	}

	.customer-card.claimed .card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
		padding-bottom: 8px;
		border-bottom: 1px solid rgba(255, 255, 255, 0.2);
	}

	.customer-card.claimed .card-title {
		font-size: 22px;
		font-weight: 600;
		letter-spacing: 0.5px;
	}

	.customer-card.claimed .card-actions {
		display: flex;
		gap: 20px;
	}

	.customer-card.claimed .card-actions .van-icon {
		color: rgba(255, 255, 255, 0.85);
		cursor: pointer;
		transition: transform 0.1s;
	}

	.customer-card.claimed .card-actions .van-icon:active {
		transform: scale(0.92);
	}

	/* 认领卡片信息行 */
	.customer-card.claimed .info-list {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.customer-card.claimed .info-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 15px;
		line-height: 1.4;
	}

	.customer-card.claimed .info-item {
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.customer-card.claimed .label {
		opacity: 0.85;
		font-weight: 500;
		min-width: 70px;
	}

	.customer-card.claimed .value {
		font-weight: 500;
		word-break: break-word;
	}

	.customer-card.claimed .tag-btn {
		background: rgba(255, 255, 255, 0.2);
		border-radius: 30px;
		padding: 4px 14px;
		font-size: 13px;
		cursor: pointer;
		transition: background 0.2s;
	}

	.customer-card.claimed .tag-btn:active {
		background: rgba(255, 255, 255, 0.35);
	}

	/* 箭头行 */
	.customer-card.claimed .arrow-row .info-item {
		flex: 1;
	}

	/* 标签行 */
	.customer-card.claimed .tag-row {
		align-items: flex-start;
		gap: 10px;
	}

	.customer-card.claimed .tag-list {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		align-items: center;
		flex: 1;
	}

	.customer-card.claimed .customer-tag {
		background: rgba(255, 255, 255, 0.95) !important;
		font-weight: 500 !important;
		border-radius: 30px;
		padding: 4px 12px;
		font-size: 12px;
	}

	.customer-card.claimed .add-tag {
		width: 26px;
		height: 26px;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.2);
		display: inline-flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: background 0.2s;
	}

	.customer-card.claimed .add-tag:active {
		background: rgba(255, 255, 255, 0.4);
	}

	/* ========== 未认领状态卡片（浅灰商务简约风） ========== */
	.customer-card.unclaimed {
		background: linear-gradient(135deg, #ffdbc5 0%, #d59b8a 100%);
		color: #1f2937;
		border: 1px solid #e4e7ed;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
		width: 100%;
		position: sticky;
		top: 0;
		left: 0;
		right: 0;
		z-index: 20;
		box-sizing: border-box;
	}

	.customer-card.unclaimed .card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
		padding-bottom: 8px;
		border-bottom: 1px solid #eff2f6;
	}

	.customer-card.unclaimed .card-title {
		font-size: 20px;
		font-weight: 600;
		color: #374151;
	}

	.customer-card.unclaimed .card-actions {
		position: static;
		right: auto;
		top: auto;
		transform: none;
	}

	.customer-card.unclaimed .card-actions .van-icon {
		color: #6b7280;
		cursor: pointer;
	}

	.customer-card.unclaimed .card-actions .van-icon:active {
		opacity: 0.6;
	}

	.customer-card.unclaimed .info-list {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.customer-card.unclaimed .info-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 15px;
	}

	.customer-card.unclaimed .info-item {
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.customer-card.unclaimed .label {
		color: #6c7a91;
		font-weight: 500;
		min-width: 70px;
	}

	.customer-card.unclaimed .value {
		color: #1e293b;
		font-weight: 500;
	}

	/* 未认领标签样式 */
	.customer-card.unclaimed .tag-row {
		align-items: flex-start;
		gap: 10px;
	}

	.customer-card.unclaimed .tag-list {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		align-items: center;
		flex: 1;
	}

	.customer-card.unclaimed .customer-tag {
		background: #f1f4f9 !important;
		color: #2c3e66 !important;
		border-radius: 30px;
		padding: 4px 12px;
		font-size: 12px;
	}

	.customer-card.unclaimed .add-tag {
		width: 26px;
		height: 26px;
		border-radius: 50%;
		background: #f1f4f9;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		color: #5a6e8a;
	}

	.customer-card.unclaimed .add-tag:active {
		background: #e4e7ed;
	}

	/* 分班按钮通用（两种状态下的） */
	.tag-btn {
		background: rgba(0, 0, 0, 0.08);
		border-radius: 30px;
		padding: 4px 14px;
		font-size: 13px;
		cursor: pointer;
	}

	/* 移动端适配 */
	@media (max-width: 640px) {

		.customer-card.claimed .card-title,
		.customer-card.unclaimed .card-title {
			font-size: 18px;
		}

		.customer-card.claimed .info-row,
		.customer-card.unclaimed .info-row {
			font-size: 14px;
			gap: 8px;
		}

		.label {
			min-width: 65px !important;
		}
	}

	.arrow-row .info-item {
		flex: 1;
	}

	/* 标签 */
	.tag-row {
		display: flex;
		align-items: flex-start;
		gap: 8px;
		width: 100%;
	}

	.tag-list {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		align-items: center;
		flex: 1;
	}

	.tag-list .van-tag {
		background: rgba(255, 255, 255, 0.95) !important;
		font-weight: bold !important;
		flex-shrink: 0;
	}

	.add-tag {
		width: 24px;
		height: 24px;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.2);
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		flex-shrink: 0;
		margin-top: 2px;
	}

	.tag-scroll-wrapper {
		display: flex;
		align-items: center;
		flex: 1;
		gap: 8px;
		min-width: 0;
	}

	.tag-list::-webkit-scrollbar {
		display: none;
	}

	.customer-tag {
		background: rgba(255, 255, 255, 0.95) !important;
		font-weight: bold !important;
		flex-shrink: 0;
		white-space: nowrap;
		max-width: 120px;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.add-tag-fixed {
		width: 24px;
		height: 24px;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.2);
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		flex-shrink: 0;
	}

	/* 时间轴 */
	.record-container {
		padding: 20px;
		width: 100%;
	}

	.record-header {
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;
	}

	.record-title {
		font-size: 20px;
		font-weight: 600;
	}

	.add-btn {
		display: flex;
		align-items: center;
		gap: 4px;
		color: #1677ff;
		border: solid 1px #1677ff;
		border-radius: 10px;
		padding: 0 4px;
	}

	.timeline {
		position: relative;
		background: #fff;
		padding: 10px 24px;
		border-radius: 10px;
	}

	.timeline::before {
		content: '';
		position: absolute;
		left: 15px;
		top: 0;
		bottom: 0;
		width: 1px;
		background: #e5e7eb;
	}

	.timeline-item {
		position: relative;
		padding-bottom: 24px;
	}

	.timeline-item:last-child::after {
		display: none;
	}

	.timeline-dot {
		position: absolute;
		left: -16px;
		top: 2px;
		width: 16px;
		height: 16px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.timeline-dot.success {
		background: #00b42a;
	}

	.timeline-dot.normal {
		background: #c9c9c9;
	}

	.timeline-content {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.timeline-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.timeline-title {
		font-size: 18px;
		font-weight: 500;
		color: #333;
	}

	.timeline-time {
		font-size: 14px;
		color: #999;
	}

	.timeline-desc {
		font-size: 16px;
		color: #666;
	}

	.timeline-bubble {
		background: #f7f8fa;
		border-radius: 8px;
		padding: 12px 16px;
		font-size: 16px;
		color: #333;
	}

	.timeline-tag {
		display: inline-block;
		background: #fff2e8;
		color: #ff7d00;
		padding: 2px 8px;
		border-radius: 4px;
		font-size: 12px;
		align-self: flex-start;
	}

	.timeline-operator {
		display: flex;
		align-items: center;
		gap: 4px;
		font-size: 12px;
		color: #999;
	}

	:deep(.van-tabs__nav) {
		background-color: #fff;
	}

	/* 订单 */
	.order-container {
		padding: 20px;
		background: #f5f5f5;
		min-height: calc(100vh - 320px);
		position: relative;
	}

	.order-list {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.order-item {
		background: #f7f8fa;
		border-radius: 12px;
		padding: 20px;
		transition: all 0.3s ease;
	}

	.order-header {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}

	.order-info {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.order-no {
		font-size: 20px;
		font-weight: 600;
		color: #333;
	}

	.order-project {
		font-size: inherit;
		color: #666;
	}

	.order-status {
		padding: 4px 12px;
		border-radius: 6px;
		font-size: inherit;
		font-weight: 500;
	}

	.order-status.paid {
		background: #e6f7e6;
		color: #00b42a;
	}

	.order-expand-trigger {
		display: flex;
		justify-content: center;
		padding: 8px 0 0;
		cursor: pointer;
	}

	.order-detail {
		margin-top: 16px;
		padding-top: 16px;
		border-top: 1px solid #eee;
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.detail-row {
		display: flex;
		justify-content: space-between;
		font-size: 14px;
	}

	.detail-label {
		color: #999;
	}

	.detail-value {
		color: #333;
	}

	.float-add-btn {
		position: fixed;
		bottom: 80px;
		right: 20px;
		width: 56px;
		height: 56px;
		border-radius: 50%;
		background: #6366f1;
		box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		z-index: 99;
	}

	/* 学情 */
	.study-container {
		padding: 20px;
		min-height: calc(100vh - 320px);
		width: 100%;
	}

	.course-selector {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-bottom: 24px;
	}

	.course-label {
		color: #f5a623;
		font-size: 16px;
	}

	.course-name {
		color: #f5a623;
		font-size: 18px;
		font-weight: 500;
	}

	.progress-grid {
		display: flex;
		justify-content: space-around;
		width: 100%;
		background: #fff;
		padding: 20px;
		border-radius: 20px;
	}

	.progress-item {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.circle-progress {
		width: 70px;
		height: 70px;
		border-radius: 50%;
		background: #f2f3f5;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 8px;
	}

	.circle-inner {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #fff;
		position: relative;
	}

	.circle-inner::before {
		content: "";
		position: absolute;
		width: 50px;
		height: 50px;
		background: #fff;
		border-radius: 50%;
	}

	.progress-text {
		position: relative;
		font-size: 16px;
		font-weight: bold;
		color: #333;
	}

	.progress-label {
		font-size: 12px;
		color: #666;
		text-align: center;
	}

	.divider {
		height: 1px;
		background: #eee;
		margin: 10px 0;
	}

	.exam-section {
		margin-top: 16px;
	}

	.exam-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 16px;
	}

	.exam-title {
		font-size: 16px;
		font-weight: 500;
	}

	.exam-avg {
		font-size: 14px;
		color: #1677ff;
	}

	.exam-list {
		display: flex;
		flex-direction: column;
		gap: 12px;
		background: #fff;
		padding: 20px;
		border-radius: 20px;
	}

	.exam-item {
		display: flex;
		justify-content: space-between;
		font-size: 14px;
		color: #666;
	}

	/* 开班 */
	/* 开班整体容器 */
	.class-container {
		padding: 15px;
		box-sizing: border-box;
		width: 100%;
	}

	/* 头部：标题 + 更新时间 + 刷新按钮 */
	.class-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: 8px;
		margin-bottom: 16px;
	}

	.header-left {
		display: flex;
		align-items: baseline;
		gap: 12px;
		flex-wrap: wrap;
	}

	.header-right {
		display: flex;
		align-items: center;
		gap: 8px;
		flex: 1;
		min-width: 200px;
		/* 保证搜索框有足够空间 */
	}

	/* 让搜索框占满剩余宽度 */
	.header-right .van-search {
		flex: 1;
	}

	.class-title {
		font-size: clamp(16px, 4vw, 18px);
		font-weight: 600;
		color: #333;
		white-space: nowrap;
	}

	.class-update {
		font-size: clamp(12px, 3vw, 13px);
		color: #999;
		white-space: nowrap;
	}

	/* 列表 */
	.class-list {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	/* 单个开班卡片 */
	.class-item {
		background: #fff;
		border-radius: 12px;
		padding: clamp(12px, 3vw, 16px);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
		border: 1px solid #f2f2f2;
	}

	/* 班级名称行 */
	.class-item-title {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-bottom: 10px;
	}

	.class-tag {
		width: 4px;
		height: 16px;
		background: #1989fa;
		border-radius: 2px;
	}

	.class-name {
		font-size: clamp(15px, 4vw, 16px);
		font-weight: 600;
		color: #333;
	}

	/* 信息行（自动换行不挤压） */
	.class-info-row {
		display: flex;
		flex-wrap: wrap;
		gap: 8px 16px;
		margin-bottom: 8px;
	}

	/* 单项信息 */
	.class-info {
		display: flex;
		align-items: center;
		gap: 6px;
		font-size: clamp(13px, 3.5vw, 14px);
		color: #666;
		white-space: nowrap;
	}

	.class-info .info-text {
		font-size: inherit;
	}

	/* 报名截止（红色强调） */
	.class-info.deadline {
		color: #f53f3f;
		font-weight: 500;
	}

	/* 雷达 */
	.radar-container {
		padding: 20px;
		min-height: calc(100vh - 320px);
		width: 100%;
	}

	.radar-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
	}

	.radar-title {
		font-size: 20px;
		font-weight: 600;
		color: #333;
	}

	.radar-date {
		font-size: 14px;
		color: #999;
	}

	.radar-table {
		background: #f7f8fa;
		border-radius: 12px;
		overflow: hidden;
	}

	.table-header {
		display: flex;
		padding: 16px 20px;
		background: #f0f2f5;
	}

	.table-th {
		font-size: 16px;
		font-weight: 500;
		color: #666;
		flex: 1;
	}

	.table-th:last-child {
		text-align: right;
	}

	.table-body {
		display: flex;
		flex-direction: column;
	}

	.table-row {
		display: flex;
		padding: 16px 20px;
		border-bottom: 1px solid #eee;
	}

	.table-row:last-child {
		border-bottom: none;
	}

	.table-td {
		font-size: 16px;
		flex: 1;
	}

	.page-name {
		color: #333;
	}

	.duration {
		color: #1677ff;
		font-weight: 500;
		text-align: right;
	}

	/* 工具 */
	.tool-container {
		min-height: calc(100vh - 320px);
		width: 100%;
	}

	.tool-sub-tabs {
		margin-bottom: 20px;
	}

	.tool-sub-tabs :deep(.van-tabs__nav) {
		background: #fff;
	}

	.tool-sub-tabs :deep(.van-tab__text) {
		font-size: 16px;
	}

	.tool-sub-tabs :deep(.van-tabs__line) {
		background-color: #1677ff;
	}

	.tool-list {
		padding: 0 16px;
		display: flex;
		flex-direction: column;
		gap: 20px;
	}

	.tool-group {
		background: #f9fafc;
		border-radius: 12px;
		border: 1px solid #f0f0f0;
		overflow: hidden;
	}

	.tool-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px;
		border-bottom: 1px solid #eee;
		cursor: pointer;
	}

	.tool-item:last-child {
		border-bottom: none;
	}

	.tool-left {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.tool-icon {
		width: 24px;
		height: 24px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.tool-info {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.tool-name {
		font-size: 18px;
		font-weight: 500;
		color: #333;
	}

	.tool-desc {
		font-size: 14px;
		color: #999;
	}

	/* 班级企业 */
	.class-enterprise-container {
		padding: 20px;
		background: #f5f7fa;
		min-height: calc(100vh - 320px);
		width: 100%;
	}

	.class-card {
		background: #fff;
		border-radius: 16px;
		padding: 20px;
		margin-bottom: 16px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
	}

	.class-card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 16px;
		padding-bottom: 16px;
		border-bottom: 1px solid #f2f3f5;
	}

	.class-student-base {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.class-student-name {
		font-size: 17px;
		font-weight: 600;
		color: #333;
	}

	.class-student-phone {
		font-size: 14px;
		color: #666;
	}

	.class-student-tags {
		display: flex;
		gap: 8px;
	}

	.tag-status {
		padding: 4px 10px;
		border-radius: 20px;
		font-size: 12px;
		font-weight: 500;
	}

	.tag-status.fb {
		background: #e6f7ff;
		color: #1677ff;
	}

	.tag-status.zl {
		background: #f0fdf4;
		color: #00b42a;
	}

	.class-card-body {
		display: flex;
		flex-direction: column;
		gap: 12px;
		margin-bottom: 12px;
	}

	.class-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 15px;
	}

	.class-label {
		color: #999;
		min-width: 70px;
	}

	.class-value {
		color: #333;
		font-weight: 500;
		text-align: right;
		flex: 1;
	}

	.order-no {
		color: #1677ff;
	}

	/* 订单卡片 */
	.order-page-container {
		padding: 20px;
		background: #f5f7fa;
		min-height: calc(100vh - 320px);
		width: 100%;
	}

	.order-card {
		background: #fff;
		border-radius: 16px;
		padding: 20px;
		margin-bottom: 16px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
	}

	.order-card-header {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		padding-bottom: 16px;
		margin-bottom: 16px;
		border-bottom: 1px solid #f2f3f5;
	}

	.order-left {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.order-no {
		font-weight: 600;
		color: #333;
	}

	.order-project {
		color: #666;
	}

	.order-status-badge {
		padding: 4px 12px;
		border-radius: 20px;
		font-weight: 500;
	}

	.order-status-badge.paid {
		background: #f0fdf4;
		color: #00b42a;
	}

	.order-status-badge.unpaid {
		background: #fff7ed;
		color: #ff7d00;
	}

	.order-card-body {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.order-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.order-label {
		color: #999;
		min-width: 70px;
	}

	.order-value {
		color: #333;
		font-weight: 500;
		text-align: right;
		flex: 1;
	}

	.order-value.price {
		color: #1677ff;
		font-size: 15px;
	}

	.order-empty {
		padding: 60px 0;
		text-align: center;
		color: #999;
	}

	/* 悬浮按钮 */
	.float-btn {
		position: fixed;
		right: 6px;
		top: 50%;
		transform: translateY(-50%);
		width: 38px;
		padding: 10px 4px;
		background: #1677ff;
		color: #fff;
		font-size: 20px;
		border-radius: 6px;
		text-align: center;
		letter-spacing: 1px;
		box-shadow: 0 2px 10px rgba(22, 119, 255, 0.3);
		z-index: 999;
		cursor: pointer;
		user-select: none;
	}

	.float-btn:active {
		background: #0E65D5;
	}

	/* 自适应版 — 转换客户按钮 */
	.convert-btn {
		position: fixed;
		right: 6px;
		top: 45%;
		transform: translateY(-50%);
		width: 34px;
		min-height: 90px;
		background: #6366f1;
		color: #fff;
		font-size: 15px;
		border-radius: 8px;
		text-align: center;
		box-shadow: 0 3px 12px rgba(99, 102, 241, 0.25);
		z-index: 999;
		cursor: pointer;
		user-select: none;

		/* 竖排居中 */
		display: flex;
		align-items: center;
		justify-content: center;
		writing-mode: vertical-rl;
		text-orientation: upright;
		/* 文字正向站立 */
		letter-spacing: 2px;
		line-height: 1;
	}

	.convert-btn:active {
		opacity: 0.85;
	}

	:deep(.order-price-input .van-field__control) {
		border: 1px solid #eee !important;
		border-radius: 6px !important;
		padding: 8px 12px !important;
		width: 100% !important;
	}

	/* 左侧竖排TAB容器 */
	.left-tab-bar {
		width: 120px;
		background: #f7f8fa;
		border-right: 1px solid #eee;
		height: 100%;
		overflow-y: auto;
	}

	/* 单个TAB */
	.tab-item {
		padding: 14px 10px;
		text-align: center;
		font-size: 14px;
		color: #333;
		cursor: pointer;
		border-bottom: 1px solid #f0f0f0;
	}

	/* 选中状态 */
	.tab-item.active {
		background: #fff;
		color: #1989fa;
		font-weight: 600;
		border-left: 3px solid #1989fa;
	}

	/* 右侧内容 */
	.right-content {
		flex: 1;
		padding: 10px;
		overflow-y: auto;
	}

	.card-actions {
		display: flex;
		align-items: center;
		gap: 12px;
		margin: 0;
		padding: 0;
	}

	/* 报名助手弹窗响应式 */
	/* 报名助手弹窗响应式 */
	:deep(.van-dialog) {
		width: 90% !important;
		max-width: 500px !important;
		border-radius: 20px;
	}

	:deep(.van-dialog__content) {
		max-height: 70vh;
		overflow-y: auto;
		padding: 12px;
	}

	:deep(.van-field) {
		margin-bottom: 0;
	}

	:deep(.van-field__label) {
		width: 80px !important;
		flex-shrink: 0;
	}

	:deep(.van-field__body) {
		flex: 1;
		overflow-x: visible;
		/* 禁止横向滚动 */
	}

	/* 选项区域：允许换行，文字不换行 */
	:deep(.van-field__body .van-checkbox__label) {
		white-space: nowrap;
	}

	/* 小屏缩小字体 */
	@media (max-width: 480px) {
		:deep(.van-checkbox__label) {
			font-size: 12px;
		}

		:deep(.van-field__label) {
			font-size: 13px;
		}

		.pc-select {
			font-size: 13px;
			padding: 6px 8px;
		}
	}

	/* 其他输入框样式 */
	.pc-select {
		width: 100%;
		padding: 8px 10px;
		border: 1px solid #e5e7eb;
		border-radius: 8px;
		font-size: 14px;
		background: #fff;
	}

	.order-price-input :deep(.van-field__control) {
		border: 1px solid #e5e7eb !important;
		border-radius: 8px !important;
		padding: 5px 12px !important;
		font-size: 14px;
	}

	/* 强制 van-checkbox 为圆形 */
	:deep(.circle-checkbox .van-checkbox__icon) {
		border-radius: 50% !important;
		overflow: hidden !important;
	}

	:deep(.circle-checkbox .van-checkbox__icon .van-icon) {
		border-radius: 50% !important;
	}

	/* 确保未选中时边框也是圆形 */
	:deep(.circle-checkbox .van-checkbox__icon--round) {
		border-radius: 50% !important;
	}

	/* 针对不同 Vant 版本，覆盖图标容器 */
	:deep(.circle-checkbox .van-checkbox__icon-wrap) {
		border-radius: 50% !important;
	}

	.submit-order-btn {
		border-radius: 40px !important;
		/* 稍圆但不过分 */
		font-size: 15px !important;
		padding: 10px 16px !important;
		height: auto !important;
		background: linear-gradient(135deg, #1677ff, #0958d9) !important;
		/* 可选渐变 */
		border: none !important;
		font-weight: 500;
		box-shadow: 0 2px 6px rgba(22, 119, 255, 0.3);
		transition: all 0.2s;
	}

	.submit-order-btn:active {
		transform: scale(0.98);
		opacity: 0.9;
	}

	/* 资料收集弹窗样式 */
	.material-order-card {
		background: #f8f9fa;
		border-radius: 12px;
		padding: 16px;
		margin-bottom: 16px;
	}

	.material-order-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 12px;
		padding-bottom: 8px;
		border-bottom: 1px solid #eee;
	}

	.material-order-header .order-project {
		font-weight: 600;
		font-size: 15px;
	}

	.order-status.status-collecting {
		color: #f59e0b;
		background: #fff7e6;
		padding: 2px 8px;
		border-radius: 20px;
		font-size: 12px;
	}

	.order-status.status-pending {
		color: #3b82f6;
		background: #eff6ff;
		padding: 2px 8px;
		border-radius: 20px;
		font-size: 12px;
	}

	.order-status.status-pass {
		color: #10b981;
		background: #e6f7e6;
		padding: 2px 8px;
		border-radius: 20px;
		font-size: 12px;
	}

	.order-status.status-reject {
		color: #ef4444;
		background: #fee2e2;
		padding: 2px 8px;
		border-radius: 20px;
		font-size: 12px;
	}

	.required-fields-list {
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
		margin: 12px 0;
	}

	.required-field-item {
		display: flex;
		align-items: center;
		gap: 6px;
		font-size: 13px;
	}

	.material-order-footer {
		text-align: right;
		margin-top: 8px;
	}

	.material-form-section {
		margin-bottom: 24px;
	}

	.section-title {
		font-size: 16px;
		font-weight: 600;
		margin-bottom: 16px;
		padding-left: 8px;
		border-left: 3px solid #1677ff;
	}

	.upload-row {
		display: flex;
		gap: 20px;
		flex-wrap: wrap;
	}

	.upload-item {
		text-align: center;
	}

	.upload-label {
		font-size: 13px;
		color: #666;
		margin-bottom: 8px;
	}

	.upload-box {
		width: 120px;
		height: 80px;
		background: #f2f3f5;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		border: 1px dashed #ddd;
	}

	.upload-box.large {
		width: 200px;
		height: 260px;
	}

	.upload-preview {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.upload-placeholder {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 4px;
		font-size: 12px;
		color: #999;
	}

	.form-row {
		margin-bottom: 16px;
	}

	.form-label {
		font-size: 14px;
		font-weight: 500;
		margin-bottom: 8px;
	}
</style>